import React, { useCallback, useEffect, useMemo, useRef } from "react";
import {
  Edit,
  WorkOutline,
  Lock,
  Tag,
  FilterList,
  Brush,
  Tune,
  Person as PersonIconMui,
  PersonOff,
  Person as PersonIconAtivar,
  AdminPanelSettings,
  Security,
  People,
  Groups,
  Diversity3,
  ExpandMore,
  ExpandLess,
  Remove,
  Add,
  Delete,
} from "@mui/icons-material";
import TableCard from "../../components/TableCard";
import Loading from "../../components/Loading";
import styles from "./styles.module.css";
import { useState } from "react";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Link as MuiLink,
  Paper,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupIcon from "@mui/icons-material/Group";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import {
  atualizarAtivacaoUsuario,
  atualizarUsuario,
  buscarComboPorCodigo,
  listarUsuariosCatalogo,
  listarAssociadosFiltroUsuarios,
  criarUsuarioGerenciamento,
  enviarTokenRedefinicaoDeSenha,
  uploadDocumentoUsuarioTxm220,
  deleteDocumentoUsuarioTxm220,
  getUsuarioDetalheGerenciamento,
  getPermissoesArvoreUsuario,
  getPermissoesUsuario,
  buscarGruposUsuarios,
  getGrupoPermissoesParaUsuario,
  buscarNiveisAssociacaoGerenciamento,
} from "../../services/auth.service";
import { listarAssociados } from "../../services/api-associados-parceiros.service";
import { Link } from "react-router-dom";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";
import GenericDatePicker from "../../components/GenericDatePicker";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import { generateRandomPassword } from "../../utils/generatePassword.util";
import { validarFormatacaoDocumento } from "../../services/validation.service";
import {
  IfPermissao,
  CHAVES_CRIAR_USUARIO,
  CHAVES_ATUALIZAR_USUARIO,
  CHAVES_GERENCIAMENTO_USUARIOS,
  CHAVES_VISUALIZAR_PERFIL_USUARIO,
  usePermissoes,
} from "../../config/Context/PermissoesContext";
import { consultarCNPJUsuario } from "../../services/auth.service";

/** Herança via grupo: árvore lista permissões diretas + herdadas dos grupos selecionados. */
// Removido: const PERMISSOES_HERDADAS_GRUPO_VAZIAS = Object.freeze([]);

const COR_ICON_BG_GRUPO = {
  purple: "#ede7f6",
  blue: "#e8f0fe",
  green: "#e6f4ea",
  orange: "#fef7e0",
  teal: "#e0f2f1",
  red: "#fce8e6",
  cyan: "#e0f7fa",
  pink: "#fce4ec",
  indigo: "#e8eaf6",
};
const COR_ICON_FG_GRUPO = {
  purple: "#673ab7",
  blue: "#1a73e8",
  green: "#34a853",
  orange: "#fa7b17",
  teal: "#009688",
  red: "#ea4335",
  cyan: "#00bcd4",
  pink: "#e91e63",
  indigo: "#3f51b5",
};

const NIVEIS_ASSOCIACAO_FALLBACK = [
  {
    idNivelAssociacao: 1,
    chave: "super_admin",
    nome: "Super Administrador",
    descricao: "Usuários Super Admin têm acesso total",
  },
  {
    idNivelAssociacao: 2,
    chave: "financeiro",
    nome: "Financeiro",
    descricao: "Usuários do nível Financeiro",
  },
  {
    idNivelAssociacao: 3,
    chave: "ti",
    nome: "TI",
    descricao: "Usuários do nível TI",
  },
  {
    idNivelAssociacao: 4,
    chave: "nivel_acesso_comum",
    nome: "Nível de Acesso Comum",
    descricao: "Usuários com nível de acesso comum",
  },
];

const NIVEL_ASSOCIACAO_CARD_ICONS = [Security, AdminPanelSettings, People, Groups, PersonIconMui, Diversity3];

function normalizarNivelAssociacaoUsuario(nivel) {
  const ordem = Number(nivel?.ordem);
  const chave = String(nivel?.chave ?? "").trim().toLowerCase();
  const nome = String(nivel?.nome ?? "").trim().toLowerCase();
  if (["admin", "administrador", "gestor"].includes(chave) || ["administrador", "gestor"].includes(nome)) {
    return null;
  }
  if (
    ordem === 6 ||
    chave === "nivel_acesso_comum" ||
    chave === "todos_com_permissao" ||
    chave === "todos-com-permissao" ||
    nome === "nível de acesso comum" ||
    nome === "nivel de acesso comum" ||
    nome === "todos com permissão" ||
    nome === "todos com permissao"
  ) {
    return {
      ...nivel,
      chave: "nivel_acesso_comum",
      nome: "Nível de Acesso Comum",
      descricao: "Usuários com nível de acesso comum",
    };
  }
  if (ordem === 5 || chave === "lider_equipe" || chave === "lider-de-equipe" || nome === "líder de equipe" || nome === "lider de equipe") {
    return {
      ...nivel,
      chave: "financeiro",
      nome: "Financeiro",
      descricao: "Usuários do nível Financeiro",
    };
  }
  if (ordem === 4 || chave === "ti" || chave === "coordenador" || nome === "ti" || nome === "coordenador") {
    return {
      ...nivel,
      chave: "ti",
      nome: "TI",
      descricao: "Usuários do nível TI",
    };
  }
  return nivel;
}

function deduplicarNiveisAssociacao(niveis = []) {
  const porChave = new Map();
  niveis.filter(Boolean).forEach((nivel) => {
    const chave = String(nivel?.chave ?? "").trim().toLowerCase();
    if (!chave || porChave.has(chave)) return;
    porChave.set(chave, nivel);
  });
  return Array.from(porChave.values());
}

function formatarResumoNomesSelecionados(nomes = [], vazio = "Nenhum selecionado") {
  const lista = [...new Set(nomes.map((nome) => String(nome ?? "").trim()).filter(Boolean))];
  if (lista.length === 0) return vazio;
  if (lista.length <= 3) return lista.join(" / ");
  return `${lista.slice(0, 3).join(" / ")} +${lista.length - 3}`;
}

function flagsParaNivelAssociacaoId(niveis = {}) {
  if (niveis.nacional) return 1;
  if (niveis.consolidado) return 2;
  if (niveis.regional) return 3;
  return null;
}

function niveisAssociacaoIdsParaFlags(ids = []) {
  const list = Array.isArray(ids) ? ids.map(Number).filter((id) => Number.isInteger(id)) : [];
  return {
    nacional: list.includes(1),
    consolidado: list.includes(2),
    regional: list.includes(3),
  };
}

/** Formata CPF (11 dígitos) ou CNPJ (14 dígitos) para exibição. Retorna "" se vazio (evita "—" no input). */
function formatarDocumento(doc) {
  if (doc == null || doc === "") return "";
  const nums = String(doc).replace(/\D/g, "");
  if (nums.length === 11) return nums.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  if (nums.length === 14) return nums.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return nums ? String(doc) : "";
}

/** Data de expiração para API: vazio ou inválido → null (evita "" e Invalid date no Postgres). */
function dtExpiracaoParaApi(value) {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Resolve nome de exibição de documento — substitui hash gerado pelo sistema por label amigável. */
function nomeDocumento(nome, tipo) {
  if (!nome) return "";
  const ext = nome.split(".").pop() || "";
  if (/^u-\d+-[a-z0-9]+\.\w+$/i.test(nome)) {
    const label = tipo === "contrato_social" ? "Contrato Social" : "Cartão CNPJ";
    return ext ? `${label}.${ext}` : label;
  }
  return nome;
}

/** Retorna iniciais do nome (ex.: "Maria Silva" -> "MS") */
function iniciais(nome) {
  if (!nome) return "?";
  return nome
    .trim()
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

/**
 * Mescla fontes de dados complementares (lista + GET detalhe). O axios já devolve o body em `res.usuario`, não `res.data.usuario`.
 */
function mergeDadosComplementaresParaForm(...fontes) {
  const base = {
    rg: "",
    estrangeiro: false,
    passaporte: "",
    rne: "",
    contratoSocialUrl: "",
    cartaoCnpjUrl: "",
    socios: [{ cpf: "", nome: "" }],
  };
  let out = { ...base };
  for (const src of fontes) {
    if (src == null || typeof src !== "object") continue;
    out = { ...out, ...src };
    if (Array.isArray(src.socios) && src.socios.length > 0) {
      out.socios = src.socios.map((soc) => ({
        cpf: soc?.cpf ?? "",
        nome: soc?.nome ?? "",
      }));
    }
  }
  return out;
}

/** Chave de permissão (catálogo) a partir do item da árvore ou da API — id/chave como string. */
function chavePermissaoSelecao(p) {
  if (p == null || typeof p !== "object") return "";
  const v = p.id ?? p.chave;
  const s = typeof v === "string" ? v : v != null ? String(v) : "";
  return s.trim();
}

function listarPermissoesDaArvore(arvore) {
  if (!Array.isArray(arvore)) return [];
  return arvore.flatMap((modulo) =>
    modulo?.subcategorias?.length
      ? modulo.subcategorias.flatMap((sub) => sub.permissoes ?? [])
      : modulo?.permissoes ?? []
  );
}

function permissaoEstaSelecionada(permissao, permissoesHerdadas = [], permissoesSelecionadas = []) {
  const chave = permissao?.chave;
  const descricao = (permissao?.descricao || "").trim();
  if (chave && permissoesHerdadas.includes(chave)) return true;
  return permissoesSelecionadas.some(
    (selecionada) => selecionada.id === chave || (selecionada.label || "").trim() === descricao
  );
}

function contarPermissoesSelecionadas(permissoes, permissoesHerdadas = [], permissoesSelecionadas = []) {
  return (permissoes ?? []).filter((p) =>
    permissaoEstaSelecionada(p, permissoesHerdadas, permissoesSelecionadas)
  ).length;
}

function montarEstadoExpansaoPermissoes(arvore, expandir) {
  const modulos = {};
  const subcategorias = {};
  (Array.isArray(arvore) ? arvore : []).forEach((modulo) => {
    modulos[modulo.id] = expandir;
    (modulo.subcategorias || []).forEach((sub) => {
      subcategorias[`${modulo.id}-${sub.id}`] = expandir;
    });
  });
  return { modulos, subcategorias };
}

function aguardarFeedbackSalvamento(ms = 1200) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function comVisualizarImplicito(chaves, arvore) {
  const result = new Set(chaves);
  for (const menu of arvore || []) {
    const subs = (menu.subcategorias || []).length > 0
      ? menu.subcategorias
      : [{ permissoes: menu.permissoes ?? [] }];
    for (const sub of subs) {
      const permKeys = (sub.permissoes || []).map((p) => p.chave);
      const readKeys = permKeys.filter((k) => { const lk = k.toLowerCase(); return lk.includes("read") || lk.includes("view"); });
      const deleteKeys = permKeys.filter((k) => k.toLowerCase().includes("delete"));
      const editKeys = permKeys.filter((k) => { const lk = k.toLowerCase(); return lk.includes("edit") || lk.includes("update"); });
      const temOutra = permKeys.some((k) => { const lk = k.toLowerCase(); return !(lk.includes("read") || lk.includes("view")) && result.has(k); });
      const temEdit = editKeys.some((k) => result.has(k));
      if (temOutra) readKeys.forEach((k) => result.add(k));
      if (temEdit) deleteKeys.forEach((k) => result.add(k));
    }
  }
  return [...result];
}

/** Chaves que liberam mutação na lista / novo cadastro (checagem explícita nas chaves da sessão — evita coluna Ações / Novo com só `read-users`). */
const CHAVE_UPDATE_USERS = "update-users";
const CHAVE_CREATE_USERS = "create-users";
const CHAVE_EDIT_USERS_LEGACY = "edit-users";

const Usuarios = () => {
  const { pode, carregado, carregando, chaves, grupoTecnico, superAdmin, recarregar } = usePermissoes();
  /** Chaves normalizadas (minúsculas) — API/localStorage podem variar capitalização. */
  const chavesNorm = useMemo(
    () =>
      (Array.isArray(chaves) ? chaves : []).map((c) => String(c ?? "").trim().toLowerCase()).filter(Boolean),
    [chaves]
  );
  const temChave = (k) => chavesNorm.includes(k.toLowerCase());
  /**
   * Somente `read-users` (visualizar usuários): lista sem coluna Ações e sem “Novo usuário”.
   * Usa `chaves` explícitas + grupo técnico (não só `pode()`, para alinhar ao retorno real de minhas-permissoes).
   */
  const podeExibirAcoesMutacaoNaLista =
    carregado &&
    !carregando &&
    (grupoTecnico ||
      temChave(CHAVE_UPDATE_USERS) ||
      temChave(CHAVE_EDIT_USERS_LEGACY));
  const podeExibirBotaoNovoUsuario =
    carregado &&
    !carregando &&
    (grupoTecnico || temChave(CHAVE_CREATE_USERS));
  /** Perfil somente leitura abre o cadastro para consulta pela linha; sem ações de editar/salvar/criar. */
  const podeExibirVerDetalheUsuario =
    carregado &&
    !carregando &&
    (grupoTecnico || pode(CHAVES_VISUALIZAR_PERFIL_USUARIO)) &&
    !podeExibirAcoesMutacaoNaLista;
  const podeGerenciarNiveisAssociacao = Boolean(superAdmin);

  const optionsFilterStatus = [
    { value: "Todos os Status" },
    { value: "Ativos" },
    { value: "Inativos" },
  ];

  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openReativarModal, setOpenReativarModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [showAdminSenha, setShowAdminSenha] = useState(false);
  const [sendingPasswordEmail, setSendingPasswordEmail] = useState(false);
  const [salvandoUsuario, setSalvandoUsuario] = useState(false);
  /** Modal de usuário existente aberto só para leitura (ex.: perfil com `read-users` sem `update-users`). */
  const [modalUsuarioSomenteLeitura, setModalUsuarioSomenteLeitura] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [data, setData] = useState([]);
  const [usuSelecionado, setUsuSelecionado] = useState({});
  /** Combo legado (GRUPOUSUARIO) — só para resolver `idGrupoUsuario` no payload quando a API não envia `grupos[]`. */
  const [comboGrupos, setComboGrupos] = useState([]);
  const [gruposSelecionadosIds, setGruposSelecionadosIds] = useState([]);
  const [gruposListaModal, setGruposListaModal] = useState([]);
  const [permissoesHerdadasGrupos, setPermissoesHerdadasGrupos] = useState([]);
  /** TXM-220: chave da permissão → nome do grupo de origem (ou vários grupos separados por vírgula). */
  const [herancaGrupoPorChave, setHerancaGrupoPorChave] = useState({});
  const [openConfirmFecharEdicao, setOpenConfirmFecharEdicao] = useState(false);
  const [confirmDeleteDocOpen, setConfirmDeleteDocOpen] = useState(false);
  const pendingDeleteDocRef = useRef(null);
  const [subcategoriasExpandidas, setSubcategoriasExpandidas] = useState({});
  const [niveisSelecionados, setNiveisSelecionados] = useState({ nacional: false, consolidado: false, regional: false });
  const [niveisAssociacaoUsuarioIds, setNiveisAssociacaoUsuarioIds] = useState([]);
  const [niveisAssociacaoOptions, setNiveisAssociacaoOptions] = useState(NIVEIS_ASSOCIACAO_FALLBACK);
  const [permissoesSelecionadas, setPermissoesSelecionadas] = useState([]);
  /** Snapshot anterior de chaves herdadas dos grupos — para remover da lista “individual” o que deixou de ser herdado. */
  const permissoesHerdadasAnteriorRef = useRef([]);
  /** Última lista não vazia de herdadas (fallback se o snapshot anterior estiver vazio ao desmarcar grupos). */
  const ultimaHerdadasPopuladaRef = useRef([]);
  const [arvorePermissoes, setArvorePermissoes] = useState([]);
  const [modulosExpandidos, setModulosExpandidos] = useState({});
  const [filterStatus, setFilterStatus] = useState({ value: "Todos os Status" });
  const [filterTipo, setFilterTipo] = useState({ value: "Todos os Tipos", apiValue: null });
  const [filterGrupo, setFilterGrupo] = useState({ value: "Todos os Grupos", id: null });
  const [filterNivelAssociacao, setFilterNivelAssociacao] = useState({ value: "Todos os Níveis", id: null });
  const [filterAssociado, setFilterAssociado] = useState({ value: "Todos os Associados", id: null });
  const [optionsGrupoCatalogo, setOptionsGrupoCatalogo] = useState([{ value: "Todos os Grupos", id: null }]);
  const [optionsAssociadoCatalogo, setOptionsAssociadoCatalogo] = useState([
    { value: "Todos os Associados", id: null },
  ]);
  const [optionsVinculosCatalogo, setOptionsVinculosCatalogo] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [catalogPage, setCatalogPage] = useState(1);
  const [catalogPerPage, setCatalogPerPage] = useState(10);
  const [serverTotal, setServerTotal] = useState(0);
  const [loadingLista, setLoadingLista] = useState(false);
  /** Tipo de documento: cpf (11 dígitos) ou cnpj (14 dígitos), conforme doc §1.2 e §3.1 */
  const [tipoDocumento, setTipoDocumento] = useState("cpf");
  const [formErrors, setFormErrors] = useState({});
  const initialData = {
    id: "",
    idUsuario: "",
    login: "",
    nome: "",
    nomeCompleto: "",
    email: "",
    documento: "",
    telefone: "",
    dtExpiracao: "",
    ativo: true,
    vinculo: null,
    tipoUsuario: "operador",
    dadosComplementares: {
      rg: "",
      estrangeiro: false,
      passaporte: "",
      rne: "",
      contratoSocialUrl: "",
      cartaoCnpjUrl: "",
      socios: [{ cpf: "", nome: "" }],
    },
  };

  const [snackBar, setSnackBar] = useState({
    error: false,
    sucess: false,
    msg: "",
  });
  const [stats, setStats] = useState({ total: 0, ativos: 0, inativos: 0, pendentes: 0 });
  //#endregion

  const [loading, setLoading] = useState(false);
  const [loadingCnpjConsulta, setLoadingCnpjConsulta] = useState(false);

  const optionsFilterTipo = useMemo(
    () => [
      { value: "Todos os Tipos", apiValue: null },
      { value: "Administrador", apiValue: "administrador" },
      { value: "Responsável Comercial", apiValue: "responsavel_comercial" },
      { value: "Associado", apiValue: "associado" },
      { value: "Parceiro", apiValue: "parceiro" },
      { value: "Operador", apiValue: "operador" },
    ],
    []
  );
  const optionsFilterNivelAssociacao = useMemo(
    () => [
      { value: "Todos os Níveis", id: null },
      ...niveisAssociacaoOptions.map((nivel) => ({
        value: nivel.nome || `Nível ${nivel.idNivelAssociacao}`,
        id: nivel.idNivelAssociacao,
      })),
    ],
    [niveisAssociacaoOptions]
  );

  const optionsVinculos = useMemo(
    () => optionsVinculosCatalogo,
    [optionsVinculosCatalogo]
  );

  const niveisAssociacaoSelecionadosLabel = useMemo(() => {
    if (!Array.isArray(niveisAssociacaoUsuarioIds) || niveisAssociacaoUsuarioIds.length === 0) {
      return null;
    }
    const nomes = niveisAssociacaoUsuarioIds.map((id) => {
      const found = niveisAssociacaoOptions.find((n) => Number(n.idNivelAssociacao) === Number(id));
      return found?.nome || `Nível ${id}`;
    });
    return formatarResumoNomesSelecionados(nomes);
  }, [niveisAssociacaoUsuarioIds, niveisAssociacaoOptions]);

  const gruposSelecionadosLabel = useMemo(() => {
    if (!Array.isArray(gruposSelecionadosIds) || gruposSelecionadosIds.length === 0) {
      return "Nenhum grupo";
    }
    const nomes = gruposSelecionadosIds.map((id) => {
      const found = gruposListaModal.find((g) => String(g.id) === String(id));
      return found?.nome || `Grupo ${id}`;
    });
    return formatarResumoNomesSelecionados(nomes, "Nenhum grupo");
  }, [gruposSelecionadosIds, gruposListaModal]);

  const selecionarNivelAssociacaoUsuario = (id) => {
    if (!podeMutarUsuarioNoModal) return;
    setNiveisAssociacaoUsuarioIds((current) => {
      const idNum = Number(id);
      const list = Array.isArray(current) ? current.map(Number) : [];
      const next = list.includes(idNum) ? list.filter((item) => item !== idNum) : [...list, idNum];
      setNiveisSelecionados(niveisAssociacaoIdsParaFlags(next));
      return next;
    });
  };

  const getErrorMessage = (error) => {
    if (error == null) return "Erro desconhecido.";
    try {
      const res = error && typeof error === "object" && error.response;
      const data = res != null && typeof res === "object" && Object.prototype.hasOwnProperty.call(res, "data") ? res.data : undefined;
      const msg = (data && (data.mensagem || data.erro)) || (error.message || String(error));
      return msg || "Erro de conexão. Verifique se a API de autenticação está rodando.";
    } catch {
      return "Erro de conexão. Verifique se a API de autenticação está rodando.";
    }
  };
  const FALLBACK_MSG = "Erro de conexão. Verifique se a API de autenticação está rodando.";
  // Carrega lista de usuários e combo de grupos ao montar a página (um único useEffect)
  useEffect(() => {
    const fetchData = async () => {
      try {
        try {
          await getData();
        } catch (err) {
          const msg = (err?.response?.data?.mensagem || err?.response?.data?.erro) || err?.message || FALLBACK_MSG;
          handleSnackBar("error", msg);
        }
      } catch (e) {
        handleSnackBar("error", FALLBACK_MSG);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const carregarNiveisAssociacao = async () => {
      try {
        const res = await buscarNiveisAssociacaoGerenciamento();
        const itens = res?.data?.itens ?? res?.itens ?? [];
        setNiveisAssociacaoOptions(
          Array.isArray(itens) && itens.length > 0
            ? deduplicarNiveisAssociacao(itens.map(normalizarNivelAssociacaoUsuario))
            : NIVEIS_ASSOCIACAO_FALLBACK
        );
      } catch {
        setNiveisAssociacaoOptions(NIVEIS_ASSOCIACAO_FALLBACK);
      }
    };
    carregarNiveisAssociacao();
  }, []);

  // Colunas dos dados — **não** incluir "Ações" aqui: o TableView acrescenta o <th>Ações</th> só quando há `botoes` na linha (evita duplicar a coluna).
  const columns = useMemo(
    () => [
      "USUÁRIO",
      "DOCUMENTO",
      "TIPO",
      "ASSOCIADO",
      "GRUPOS",
      ...(podeGerenciarNiveisAssociacao ? ["NÍVEL DE ACESSO"] : []),
      "STATUS",
      "ÚLTIMO ACESSO",
    ],
    [podeGerenciarNiveisAssociacao]
  );
  const usuariosTableColumnWidths = useMemo(
    () => ({
      USUÁRIO: podeGerenciarNiveisAssociacao ? "260px" : "300px",
      DOCUMENTO: "125px",
      TIPO: "88px",
      ASSOCIADO: "120px",
      GRUPOS: "110px",
      "NÍVEL DE ACESSO": "160px",
      STATUS: "105px",
      "ÚLTIMO ACESSO": "135px",
      Ações: "88px",
    }),
    [podeGerenciarNiveisAssociacao]
  );
  const usuariosTableMinWidth = podeGerenciarNiveisAssociacao
    ? "1190px"
    : podeExibirAcoesMutacaoNaLista
      ? "1080px"
      : "980px";

  const fetchCatalog = useCallback(
    async ({ page = 1, perPage = catalogPerPage, searchOverride, silent = false } = {}) => {
      if (!silent) setLoadingLista(true);
      try {
        const statusMap = { Ativos: "active", Inativos: "inactive" };
        const statusParam =
          filterStatus?.value && filterStatus.value !== "Todos os Status"
            ? statusMap[filterStatus.value]
            : undefined;
        const tipoParam =
          filterTipo?.apiValue != null && String(filterTipo.apiValue).trim() !== ""
            ? filterTipo.apiValue
            : undefined;
        const grupoParam = filterGrupo?.id != null ? String(filterGrupo.id) : undefined;
        const nivelAssociacaoId =
          podeGerenciarNiveisAssociacao &&
          filterNivelAssociacao?.id != null &&
          !Number.isNaN(Number(filterNivelAssociacao.id))
            ? Number(filterNivelAssociacao.id)
            : undefined;
        const associadoId =
          filterAssociado?.id != null && !Number.isNaN(Number(filterAssociado.id))
            ? Number(filterAssociado.id)
            : undefined;
        const searchVal =
          searchOverride !== undefined ? String(searchOverride).trim() : searchInput.trim();
        const res = await listarUsuariosCatalogo({
          status: statusParam,
          tipo: tipoParam,
          grupo: grupoParam,
          nivel_associacao_id: nivelAssociacaoId,
          associado_id: associadoId,
          search: searchVal || undefined,
          page,
          per_page: perPage,
          sort: "name",
          order: "asc",
        });
        /** Interceptor de api.service já devolve o JSON do body (não o AxiosResponse). Payload: { sucesso, data, meta, stats }. */
        const payload = res && typeof res === "object" && !Array.isArray(res) ? res : {};
        const list = Array.isArray(payload.data) ? payload.data : Array.isArray(res) ? res : [];
        setRawData(list);
        const st = payload.stats ?? {};
        setStats({
          total: st.total ?? 0,
          ativos: st.ativos ?? 0,
          inativos: st.inativos ?? 0,
          pendentes: st.pendentes ?? 0,
        });
        setServerTotal(Number(payload.meta?.total ?? list.length));
        setCatalogPage(Number(payload.meta?.current_page ?? page));
        setCatalogPerPage(Number(payload.meta?.per_page ?? perPage));

        try {
          const [resGrupos, resAssoc, resAssocCatalogo] = await Promise.all([
            buscarGruposUsuarios(),
            listarAssociadosFiltroUsuarios(),
            listarAssociados({ per_page: 500, status: "ativo" }),
          ]);
          const gl = resGrupos?.grupos ?? resGrupos?.data?.grupos ?? resGrupos?.data ?? [];
          const arrG = Array.isArray(gl) ? gl : [];
          setOptionsGrupoCatalogo([
            { value: "Todos os Grupos", id: null },
            ...arrG.map((g) => {
              const nome = String(g.descricao ?? g.nome ?? "").split("\n")[0]?.trim() || "Grupo";
              return { value: nome, id: g.idGrupoUsuario ?? g.id_grupo_usuario };
            }),
          ]);
          const arrA = Array.isArray(resAssoc?.data)
            ? resAssoc.data
            : Array.isArray(resAssoc)
              ? resAssoc
              : [];
          setOptionsAssociadoCatalogo([
            { value: "Todos os Associados", id: null },
            ...arrA.map((a) => ({
              value: a.nome || `Associado ${a.id}`,
              id: a.id,
            })),
          ]);
          const arrCat = Array.isArray(resAssocCatalogo?.data)
            ? resAssocCatalogo.data
            : Array.isArray(resAssocCatalogo)
              ? resAssocCatalogo
              : [];
          setOptionsVinculosCatalogo(arrCat.map((a) => ({
            value: a.razao_social || a.nome || `Associado ${a.id}`,
            id: a.id,
          })));
        } catch {
          /* filtros opcionais */
        }

        let responseGrupos;
        try {
          responseGrupos = await buscarComboPorCodigo("GRUPOUSUARIO");
        } catch {
          setComboGrupos([]);
          return;
        }
        const itensCombo = responseGrupos?.detalhes?.itensCombo ?? [];
        const grupos = Array.isArray(itensCombo)
          ? itensCombo.map((item) => ({
              id: String(item).split("/|/")[0],
              label: String(item).split("/|/")[1],
            }))
          : [];
        setComboGrupos(grupos);
      } catch (err) {
        if (!silent) {
          setRawData([]);
          setStats({ total: 0, ativos: 0, inativos: 0, pendentes: 0 });
          setServerTotal(0);
          setComboGrupos([]);
        }
        throw err;
      } finally {
        if (!silent) setLoadingLista(false);
      }
    },
    [
      filterStatus,
      filterTipo,
      filterGrupo,
      filterNivelAssociacao,
      filterAssociado,
      podeGerenciarNiveisAssociacao,
      searchInput,
      catalogPerPage,
    ]
  );

  /** TXM-219: catálogo server-side; combo GRUPOUSUARIO mantido para o formulário. */
  const getData = async (options = {}) => {
    await fetchCatalog({ page: 1, perPage: catalogPerPage, ...options });
  };

  const sincronizarListaAposSalvar = () => {
    fetchCatalog({ page: 1, perPage: catalogPerPage, silent: true }).catch((err) => {
      console.warn("[Usuarios] Falha ao atualizar lista em segundo plano:", err?.message || err);
    });
    recarregar().catch((err) => {
      console.warn("[Usuarios] Falha ao atualizar permissões em segundo plano:", err?.message || err);
    });
  };

  /** Mapeia um usuário (objeto da API) para uma linha da tabela (nova tela) */
  const mapUsuarioToRow = (usuario) => {
    const nome = usuario.nomeCompleto || usuario.login || "";
    const statusKey =
      usuario.status === "active" || usuario.status === "ativo" || usuario.status_pt === "ativo"
        ? "ativo"
        : "inativo";
    const statusLabel = statusKey === "ativo" ? "Ativo" : "Inativo";
    const associadoLabel = usuario.associado?.nome ?? "Não vinculado";
    const niveisAssociacaoUsuario = Array.isArray(usuario.niveis_associacao)
      ? usuario.niveis_associacao
      : Array.isArray(usuario.niveisAssociacao)
        ? usuario.niveisAssociacao
        : [];
    const idsNiveisAssociacaoUsuario = Array.isArray(usuario.ids_niveis_associacao)
      ? usuario.ids_niveis_associacao
      : Array.isArray(usuario.idsNiveisAssociacao)
        ? usuario.idsNiveisAssociacao
        : usuario.idNivelAssociacao != null || usuario.id_nivel_associacao != null
          ? [usuario.idNivelAssociacao ?? usuario.id_nivel_associacao]
          : [];
    const niveisParaExibicao =
      niveisAssociacaoUsuario.length > 0
        ? niveisAssociacaoUsuario
        : idsNiveisAssociacaoUsuario
            .map(Number)
            .filter((id) => Number.isInteger(id) && id > 0)
            .map((id) => {
              const nivel = niveisAssociacaoOptions.find((opt) => Number(opt.idNivelAssociacao) === id);
              return { id, nome: nivel?.nome || `Nível ${id}` };
            });
    
    // Formatar último acesso: DD/MM/YYYY e HH:mm
    const formatarUltimoAcesso = (rawDate) => {
      if (!rawDate) return null;
      try {
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return null;
        
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();
        const hora = String(date.getHours()).padStart(2, '0');
        const minuto = String(date.getMinutes()).padStart(2, '0');
        
        return { data: `${dia}/${mes}/${ano}`, hora: `${hora}:${minuto}` };
      } catch {
        return null;
      }
    };
    
    const ultimoAcessoFormatado = formatarUltimoAcesso(
      usuario.ultimoAcesso ?? usuario.ultimo_acesso
    );
    const ultimoAcessoLabel = ultimoAcessoFormatado ? (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.2 }}>
          {ultimoAcessoFormatado.data}
        </Typography>
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.2 }}>
          {ultimoAcessoFormatado.hora}
        </Typography>
      </Box>
    ) : (
      <Typography variant="body2" sx={{ fontSize: '0.875rem', color: '#9e9e9e' }}>
        Nunca acessou
      </Typography>
    );
    
    return {
      usuario: (
        <Box
          className={styles.userCellWrapper}
          onClick={
            podeExibirVerDetalheUsuario
              ? (e) => {
                  e.stopPropagation();
                  handleOpenEditModal(usuario);
                }
              : undefined
          }
          onKeyDown={
            podeExibirVerDetalheUsuario
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    e.stopPropagation();
                    handleOpenEditModal(usuario);
                  }
                }
              : undefined
          }
          role={podeExibirVerDetalheUsuario ? "button" : undefined}
          tabIndex={podeExibirVerDetalheUsuario ? 0 : undefined}
          title={podeExibirVerDetalheUsuario ? "Clique para visualizar o cadastro" : undefined}
          sx={
            podeExibirVerDetalheUsuario
              ? { cursor: "pointer", borderRadius: 1, "&:focus-visible": { outline: "2px solid #1976d2", outlineOffset: 2 } }
              : undefined
          }
        >
          <Avatar className={styles.userCellAvatar}>{iniciais(nome)}</Avatar>
          <Box className={styles.userCellText}>
            <span className={styles.userCellName}>{nome || "—"}</span>
            <span className={styles.userCellEmail}>{usuario.email || "—"}</span>
          </Box>
        </Box>
      ),
      documento: (() => {
        const doc = usuario.documento || "";
        const nums = String(doc).replace(/\D/g, "");
        const tipo = nums.length === 11 ? "CPF" : nums.length === 14 ? "CNPJ" : "";
        const formatted = formatarDocumento(doc) || "—";
        
        if (!tipo) return formatted;
        
        return (
          <Box className={styles.documentCell}>
            <Typography className={styles.documentType}>{tipo}</Typography>
            <Typography className={styles.documentNumber}>{formatted}</Typography>
          </Box>
        );
      })(),
      tipo: (() => {
        const tipoConfig = {
          administrador: { label: "Administrador", bg: "#f3e5f5", color: "#7b1fa2" },
          responsavel_comercial: { label: "Responsável Comercial", bg: "#e8f5e9", color: "#1b5e20" },
          associado: { label: "Associado", bg: "#e8f0fe", color: "#1a73e8" },
          parceiro: { label: "Parceiro", bg: "#e0f7fa", color: "#00838f" },
          operador: { label: "Operador", bg: "#eceff1", color: "#546e7a" },
        };
        const raw = (usuario.tipoUsuario ?? "operador").toLowerCase();
        const config = tipoConfig[raw] ?? tipoConfig.operador;
        return (
          <Chip
            size="small"
            label={config.label}
            sx={{
              fontWeight: 500,
              bgcolor: config.bg,
              color: config.color,
              "& .MuiChip-label": { fontSize: "0.75rem" },
            }}
          />
        );
      })(),
      associado: associadoLabel,
      grupos: (() => {
        // Exibir grupos do usuário como chips
        const grupos = usuario.grupos || [];
        if (grupos.length === 0) {
          return (
            <Typography variant="body2" sx={{ fontSize: '0.875rem', color: '#9e9e9e' }}>
              Sem grupos
            </Typography>
          );
        }
        return (
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            {grupos.slice(0, 2).map((grupo, idx) => {
              const nomeGrupo = grupo.nome || grupo.descricao || `Grupo ${grupo.id || grupo.idGrupoUsuario}`;
              const cor = grupo.cor || 'blue';
              const bg = COR_ICON_BG_GRUPO[cor] || COR_ICON_BG_GRUPO.blue;
              const fg = COR_ICON_FG_GRUPO[cor] || COR_ICON_FG_GRUPO.blue;
              return (
                <Chip
                  key={idx}
                  label={nomeGrupo}
                  size="small"
                  sx={{
                    bgcolor: bg,
                    color: fg,
                    fontSize: '0.75rem',
                    height: 24,
                    fontWeight: 500,
                  }}
                />
              );
            })}
            {grupos.length > 2 && (
              <Chip
                label={`+${grupos.length - 2}`}
                size="small"
                sx={{
                  bgcolor: '#f5f5f5',
                  color: '#616161',
                  fontSize: '0.75rem',
                  height: 24,
                  fontWeight: 500,
                }}
              />
            )}
          </Box>
        );
      })(),
      ...(podeGerenciarNiveisAssociacao
        ? {
            nivelAcesso: niveisParaExibicao.length ? (
              <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                {niveisParaExibicao.slice(0, 2).map((nivel) => {
                  const idNivel = Number(nivel.id ?? nivel.idNivelAssociacao ?? nivel.id_nivel_associacao);
                  const nomeNivel = String(nivel.nome || `Nível ${idNivel}`);
                  return (
                    <Chip
                      key={`${idNivel}-${nomeNivel}`}
                      label={`${idNivel} - ${nomeNivel}`}
                      size="small"
                      sx={{
                        bgcolor: idNivel === 1 ? "#f3e5f5" : "#e3f2fd",
                        color: idNivel === 1 ? "#6a1b9a" : "#1565c0",
                        fontSize: "0.75rem",
                        height: 24,
                        fontWeight: 600,
                      }}
                    />
                  );
                })}
                {niveisParaExibicao.length > 2 && (
                  <Chip
                    label={`+${niveisParaExibicao.length - 2}`}
                    size="small"
                    sx={{ bgcolor: "#f5f5f5", color: "#616161", fontSize: "0.75rem", height: 24, fontWeight: 500 }}
                  />
                )}
              </Box>
            ) : (
              <Typography variant="body2" sx={{ fontSize: "0.875rem", color: "#9e9e9e" }}>
                Sem nível
              </Typography>
            ),
          }
        : {}),
      status: (() => {
        const statusConfig = {
          ativo: { dot: "#2e7d32", text: "#2e7d32", bg: "#e8f5e9" },
          inativo: { dot: "#c62828", text: "#c62828", bg: "#ffebee" },
        };
        const config = statusConfig[statusKey] || statusConfig.inativo;
        return (
          <Chip
            size="small"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: config.dot }} />
                <span>{statusLabel}</span>
              </Box>
            }
            sx={{
              fontWeight: 500,
              bgcolor: config.bg,
              color: config.text,
              "& .MuiChip-label": { display: "flex", alignItems: "center" },
            }}
          />
        );
      })(),
      ultimoAcesso: ultimoAcessoLabel,
      ...(podeExibirAcoesMutacaoNaLista
        ? {
            botoes: (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Editar usuário">
                  <IconButton
                    size="small"
                    onClick={() => handleOpenEditModal(usuario)}
                    sx={{
                      color: "#616161",
                      "&:hover": { bgcolor: "#e3f2fd", color: "#1565c0" },
                    }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                </Tooltip>
                {usuario.ativo ? (
                  <Tooltip title="Desativar usuário">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenModal(usuario)}
                      sx={{
                        color: "#616161",
                        "&:hover": { bgcolor: "#ffebee", color: "#c62828" },
                      }}
                    >
                      <PersonOff fontSize="small" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Ativar usuário">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenReativarModal(usuario)}
                      sx={{
                        color: "#616161",
                        "&:hover": { bgcolor: "#e8f5e9", color: "#2e7d32" },
                      }}
                    >
                      <PersonIconAtivar fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            ),
          }
        : {}),
    };
  };

  useEffect(() => {
    setData(rawData.map(mapUsuarioToRow));
  }, [
    rawData,
    podeExibirAcoesMutacaoNaLista,
    podeExibirVerDetalheUsuario,
    podeGerenciarNiveisAssociacao,
    niveisAssociacaoOptions,
  ]);

  const filtrosInicializadosRef = useRef(false);
  useEffect(() => {
    if (!filtrosInicializadosRef.current) {
      filtrosInicializadosRef.current = true;
      return;
    }
    fetchCatalog({ page: 1 });
  }, [filterStatus, filterTipo, filterGrupo, filterNivelAssociacao, filterAssociado, fetchCatalog]);

  const handleSearchByText = async (value) => {
    try {
      const v = value != null ? String(value).trim() : "";
      setSearchInput(v);
      await fetchCatalog({ page: 1, perPage: catalogPerPage, searchOverride: v });
    } catch (error) {
      handleSnackBar("error", getErrorMessage(error));
    }
  };

  const fetchCatalogRef = useRef(fetchCatalog);
  fetchCatalogRef.current = fetchCatalog;
  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        const v = value != null ? String(value).trim() : "";
        setSearchInput(v);
        fetchCatalogRef.current({ page: 1, searchOverride: v });
      }, 300),
    []
  );

  //#endregion
  const handleTratarData = (data) => {
    const splitDate = data.split("-");
    const date = `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
    return date;
  };
  //#region ------ Modais -------------
  const handleOpenModal = (usuario) => {
    setOpenModal(true);
    setUsuSelecionado(usuario);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenPasswordModal = () => {
    setOpenPasswordModal(true);
  };
  const handleClosePasswordModal = () => {
    setOpenPasswordModal(false);
  };
  const handleOpenEditModal = async (usuario) => {
    if (usuario != null) {
      if (!pode(CHAVES_GERENCIAMENTO_USUARIOS) && !pode(CHAVES_VISUALIZAR_PERFIL_USUARIO)) {
        handleSnackBar("error", "Você não tem permissão para acessar o cadastro de usuários.");
        return;
      }
      setModalUsuarioSomenteLeitura(!pode(CHAVES_ATUALIZAR_USUARIO));
    } else {
      if (!pode(CHAVES_CRIAR_USUARIO)) {
        handleSnackBar("error", "Você não tem permissão para cadastrar usuários.");
        return;
      }
      setModalUsuarioSomenteLeitura(false);
    }
    setFormErrors({});
    permissoesHerdadasAnteriorRef.current = [];
    ultimaHerdadasPopuladaRef.current = [];
    if (!usuario) {
      usuario = { ...initialData, senhaAdmin: "" };
      setTipoDocumento("cpf");
      setShowAdminSenha(false);
      setPermissoesSelecionadas([]);
      setGruposSelecionadosIds([]);
      const nivelComumPadrao = niveisAssociacaoOptions.find((n) => n.chave === "nivel_acesso_comum");
      const idsNivelPadrao = nivelComumPadrao ? [Number(nivelComumPadrao.idNivelAssociacao)] : [];
      setNiveisAssociacaoUsuarioIds(idsNivelPadrao);
      setNiveisSelecionados(
        idsNivelPadrao.length > 0
          ? niveisAssociacaoIdsParaFlags(idsNivelPadrao)
          : { nacional: false, consolidado: false, regional: false }
      );
      try {
        const resArvore = await getPermissoesArvoreUsuario();
        const arvore = resArvore?.data?.arvore ?? resArvore?.arvore ?? [];
        setArvorePermissoes(Array.isArray(arvore) ? arvore : []);
        setModulosExpandidos({});
        setSubcategoriasExpandidas({});
      } catch {
        setArvorePermissoes([]);
      }
    } else {
      let usuarioParaModal = usuario;
      const idUsuarioAlvo = usuario?.idUsuario ?? usuario?.id_usuario;
      if (idUsuarioAlvo != null && idUsuarioAlvo !== "") {
        try {
          const resDet = await getUsuarioDetalheGerenciamento(Number(idUsuarioAlvo));
          /** Interceptor em api.service devolve `response.data` — o payload é { sucesso, usuario }. */
          const uDet = resDet?.usuario ?? resDet?.data?.usuario;
          if (uDet && typeof uDet === "object") {
            usuarioParaModal = { ...usuario, ...uDet };
            const na = uDet.niveisAcesso ?? uDet.niveis_acesso;
            const idsNivelAssociacao = Array.isArray(uDet.idsNiveisAssociacao)
              ? uDet.idsNiveisAssociacao
              : Array.isArray(uDet.ids_niveis_associacao)
                ? uDet.ids_niveis_associacao
                : null;
            const idNivelAssociacao =
              uDet.idNivelAssociacao ?? uDet.id_nivel_associacao ?? uDet.nivelAssociacaoId ?? null;
            const idsNormalizados =
              idsNivelAssociacao != null
                ? idsNivelAssociacao.map(Number).filter((id) => Number.isInteger(id) && id > 0)
                : idNivelAssociacao != null && idNivelAssociacao !== ""
                  ? [Number(idNivelAssociacao)]
                  : na && typeof na === "object"
                    ? [flagsParaNivelAssociacaoId(na)].filter(Boolean)
                    : [];
            setNiveisAssociacaoUsuarioIds(idsNormalizados);
            if (na && typeof na === "object") {
              setNiveisSelecionados(idsNormalizados.length > 0 ? niveisAssociacaoIdsParaFlags(idsNormalizados) : {
                nacional: Boolean(na.nacional),
                consolidado: Boolean(na.consolidado),
                regional: Boolean(na.regional),
              });
            } else {
              setNiveisSelecionados(niveisAssociacaoIdsParaFlags(idsNormalizados));
            }
          } else {
            setNiveisAssociacaoUsuarioIds([]);
            setNiveisSelecionados({ nacional: false, consolidado: false, regional: false });
          }
        } catch (err) {
          console.error("[Usuarios] Falha ao carregar GET /gerenciamento/usuarios/:id", err);
          setNiveisAssociacaoUsuarioIds([]);
          setNiveisSelecionados({ nacional: false, consolidado: false, regional: false });
        }
      }
      usuario = usuarioParaModal;
      const docLen = String(usuario.documento ?? "").replace(/\D/g, "").length;
      const tipoDocApi = String(usuario.tipoDocumento ?? "").toLowerCase();
      setTipoDocumento("cpf");
      try {
        const idPerm = usuario.idUsuario ?? usuario.id_usuario ?? idUsuarioAlvo;
        const response = await getPermissoesUsuario(idPerm);
        const perms = response?.permissoes ?? response?.data?.permissoes ?? [];
        setPermissoesSelecionadas(Array.isArray(perms) ? perms : []);
      } catch (error) {
        handleSnackBar("error", getErrorMessage(error));
        setPermissoesSelecionadas([]);
      }
      try {
        const resArvore = await getPermissoesArvoreUsuario();
        const arvore = resArvore?.data?.arvore ?? resArvore?.arvore ?? [];
        setArvorePermissoes(Array.isArray(arvore) ? arvore : []);
        setModulosExpandidos({});
        setSubcategoriasExpandidas({});
      } catch {
        setArvorePermissoes([]);
      }
    }
    const userWithDefaults = {
      ...initialData,
      ...usuario,
      dadosComplementares: mergeDadosComplementaresParaForm(
        initialData.dadosComplementares,
        usuario.dados_complementares,
        usuario.dadosComplementares
      ),
      tipoUsuario: usuario.tipoUsuario ?? usuario.tipo_usuario ?? "operador",
      vinculo: usuario.vinculo ?? (usuario.idAssociado != null ? { nome: `Associado #${usuario.idAssociado}`, id: usuario.idAssociado } : null),
    };
    setUsuSelecionado(userWithDefaults);

    let listaGruposUi = [];
    try {
      const resG = await buscarGruposUsuarios();
      const arr = resG?.grupos ?? resG?.data?.grupos ?? [];
      listaGruposUi = (Array.isArray(arr) ? arr : []).filter((g) => g.ativo !== false).map((g) => ({
        id: String(g.idGrupoUsuario),
        nome: g.descricao || g.nome || `Grupo ${g.idGrupoUsuario}`,
        numPermissoes: g.numPermissoes != null ? Number(g.numPermissoes) : null,
        cor: String(g.cor || "blue").toLowerCase(),
        ativo: g.ativo !== false,
        nivelAssociacao: g.nivelAssociacao || null,
      }));
    } catch {
      listaGruposUi = comboGrupos.map((c) => ({
        id: String(c.id),
        nome: c.label || `Grupo ${c.id}`,
        numPermissoes: null,
        cor: "blue",
        ativo: true,
        nivelAssociacao: null,
      }));
    }
    setGruposListaModal(listaGruposUi);

    const listGrupos = comboGrupos;
    const grupo = listGrupos.find((item) => item.id == usuario.idGrupoUsuario);
    const idsFromGrupos = (() => {
      if (Array.isArray(usuario.gruposSelecionados)) {
        if (usuario.gruposSelecionados.length > 0) {
          return usuario.gruposSelecionados.map((id) => String(id)).filter(Boolean);
        }
        return [];
      }
      if (!Array.isArray(usuario.grupos) || usuario.grupos.length === 0) {
        return grupo ? [String(grupo.id)] : [];
      }
      const temFlagSelecionado = usuario.grupos.some((g) => Object.prototype.hasOwnProperty.call(g, "selecionado"));
      const lista = temFlagSelecionado ? usuario.grupos.filter((g) => g.selecionado === true) : usuario.grupos;
      return lista.map((g) => String(g.id ?? g.idGrupoUsuario ?? g)).filter(Boolean);
    })();
    permissoesHerdadasAnteriorRef.current = [];
    ultimaHerdadasPopuladaRef.current = [];
    setGruposSelecionadosIds(idsFromGrupos);
    setOpenEditModal(true);
  };
  const fecharModalEdicaoUsuario = () => {
    const active = document.activeElement;
    if (active && typeof active.blur === "function") active.blur();
    setOpenConfirmFecharEdicao(false);
    setPermissoesSelecionadas([]);
    permissoesHerdadasAnteriorRef.current = [];
    ultimaHerdadasPopuladaRef.current = [];
    setGruposListaModal([]);
    setPermissoesHerdadasGrupos([]);
    setHerancaGrupoPorChave({});
    setModalUsuarioSomenteLeitura(false);
    setOpenEditModal(false);
  };

  /** Após salvar ou fechamento forçado — sem confirmação. */
  const handleCloseEditModal = () => fecharModalEdicaoUsuario();

  /** Edição real = usuário já existe no BD (define PUT vs POST no submit). */
  const isEdicaoUsuarioExistente = (u) => {
    const id = u?.idUsuario ?? u?.id_usuario;
    if (id == null || id === "") return false;
    const n = Number(id);
    return !Number.isNaN(n) && n > 0;
  };
  /** No modal: criar exige create (ou update); editar existente exige só update-users. */
  const modoEdicaoUsuarioModal = isEdicaoUsuarioExistente(usuSelecionado);
  const podeMutarUsuarioNoModal =
    !modalUsuarioSomenteLeitura &&
    (modoEdicaoUsuarioModal ? pode(CHAVES_ATUALIZAR_USUARIO) : pode(CHAVES_CRIAR_USUARIO));

  const totalPermissoesArvore = useMemo(
    () => listarPermissoesDaArvore(arvorePermissoes).length,
    [arvorePermissoes]
  );
  const totalPermissoesSelecionadasArvore = useMemo(
    () =>
      contarPermissoesSelecionadas(
        listarPermissoesDaArvore(arvorePermissoes),
        permissoesHerdadasGrupos,
        permissoesSelecionadas
      ),
    [arvorePermissoes, permissoesHerdadasGrupos, permissoesSelecionadas]
  );
  const todasPermissoesExpandidas = useMemo(() => {
    if (!arvorePermissoes.length) return false;
    return arvorePermissoes.every((modulo) => {
      const moduloExpandido = modulosExpandidos[modulo.id] === true;
      const subcategorias = modulo.subcategorias || [];
      return moduloExpandido && subcategorias.every((sub) => subcategoriasExpandidas[`${modulo.id}-${sub.id}`] === true);
    });
  }, [arvorePermissoes, modulosExpandidos, subcategoriasExpandidas]);
  const alternarTodasPermissoes = () => {
    const { modulos, subcategorias } = montarEstadoExpansaoPermissoes(
      arvorePermissoes,
      !todasPermissoesExpandidas
    );
    setModulosExpandidos(modulos);
    setSubcategoriasExpandidas(subcategorias);
  };

  /** Cancelar / breadcrumb: confirma se o usuário pode editar (TXM-220). */
  const solicitarFecharModalEdicao = () => {
    if (podeMutarUsuarioNoModal && !modalUsuarioSomenteLeitura) {
      setOpenConfirmFecharEdicao(true);
      return;
    }
    fecharModalEdicaoUsuario();
  };

  const toggleGrupoModal = (idStr) => {
    if (!podeMutarUsuarioNoModal) return;
    setGruposSelecionadosIds((prev) => {
      const s = new Set(prev.map(String));
      if (s.has(idStr)) s.delete(idStr);
      else s.add(idStr);
      return Array.from(s);
    });
  };

  // Permissões herdadas dos grupos + mapa chave → nome do grupo (TXM-220: badge com origem)
  useEffect(() => {
    let cancelled = false;
    const resolverChave = (p) => {
      if (typeof p === "string") return p.trim();
      if (p != null && typeof p === "object" && p.chave != null) return String(p.chave).trim();
      return "";
    };
    const buscarPermissoesGrupos = async () => {
      if (!gruposSelecionadosIds || gruposSelecionadosIds.length === 0) {
        if (!cancelled) {
          setPermissoesHerdadasGrupos([]);
          setHerancaGrupoPorChave({});
        }
        return;
      }

      try {
        const permissoesSet = new Set();
        const mapHeranca = {};

        for (const idGrupo of gruposSelecionadosIds) {
          const idStr = String(idGrupo);
          const meta = gruposListaModal.find((g) => String(g.id) === idStr);
          const nomeGrupo = meta?.nome || `Grupo ${idGrupo}`;
          try {
            const res = await getGrupoPermissoesParaUsuario(Number(idGrupo));
            const permissoes = res?.permissoes ?? res?.data?.permissoes ?? [];

            permissoes.forEach((p) => {
              const chave = resolverChave(p);
              if (!chave) return;
              permissoesSet.add(chave);
              const prev = mapHeranca[chave];
              if (!prev) mapHeranca[chave] = nomeGrupo;
              else if (!String(prev).includes(nomeGrupo)) mapHeranca[chave] = `${prev}, ${nomeGrupo}`;
            });
          } catch (err) {
            console.error(`Erro ao buscar permissões do grupo ${idGrupo}:`, err);
          }
        }

        if (!cancelled) {
          setPermissoesHerdadasGrupos(Array.from(permissoesSet));
          setHerancaGrupoPorChave(mapHeranca);
        }
      } catch (error) {
        console.error("Erro ao buscar permissões dos grupos:", error);
        if (!cancelled) {
          setPermissoesHerdadasGrupos([]);
          setHerancaGrupoPorChave({});
        }
      }
    };

    buscarPermissoesGrupos();
    return () => {
      cancelled = true;
    };
  }, [gruposSelecionadosIds, gruposListaModal]);

  const totalPermissoesAtivasModal = useMemo(() => {
    const s = new Set((permissoesHerdadasGrupos || []).map(String));
    (permissoesSelecionadas || []).forEach((x) => {
      const k = String(x?.id ?? x?.chave ?? "").trim();
      if (k) s.add(k);
    });
    return s.size;
  }, [permissoesHerdadasGrupos, permissoesSelecionadas]);

  /**
   * Mantém `permissoesSelecionadas` só com extras reais (não duplicar herdadas) e, ao desmarcar grupos,
   * remove da lista as chaves que deixaram de ser herdadas (evita que fiquem como “individuais”).
   */
  useEffect(() => {
    if (!openEditModal) return;

    const curArr = Array.isArray(permissoesHerdadasGrupos) ? permissoesHerdadasGrupos : [];
    if (curArr.length > 0) {
      ultimaHerdadasPopuladaRef.current = [...curArr];
    }

    const curSet = new Set(curArr.map((k) => String(k)));

    const prevArr = Array.isArray(permissoesHerdadasAnteriorRef.current)
      ? permissoesHerdadasAnteriorRef.current
      : [];
    const prevSet = new Set(prevArr.map((k) => String(k)));

    let removidasDaHeranca = [...prevSet].filter((k) => !curSet.has(k));

    if (
      curArr.length === 0 &&
      Array.isArray(gruposSelecionadosIds) &&
      gruposSelecionadosIds.length === 0 &&
      removidasDaHeranca.length === 0 &&
      ultimaHerdadasPopuladaRef.current.length > 0
    ) {
      removidasDaHeranca = [...new Set(ultimaHerdadasPopuladaRef.current.map((k) => String(k)))];
    }

    const removidasSet = new Set(removidasDaHeranca);
    permissoesHerdadasAnteriorRef.current = [...curArr];

    if (curArr.length === 0 && Array.isArray(gruposSelecionadosIds) && gruposSelecionadosIds.length === 0) {
      ultimaHerdadasPopuladaRef.current = [];
    }

    setPermissoesSelecionadas((prev) => {
      const lista = Array.isArray(prev) ? prev : [];
      return lista.filter((s) => {
        const id = String(s.id ?? s.chave ?? "").trim();
        if (!id) return true;
        if (curSet.has(id)) return false;
        if (removidasSet.size > 0 && removidasSet.has(id)) return false;
        return true;
      });
    });
  }, [openEditModal, permissoesHerdadasGrupos, gruposSelecionadosIds]);

  const handleOpenReativarModal = (usuario) => {
    setOpenReativarModal(true);
    setUsuSelecionado(usuario);
  };
  const handleCloseReativarModal = () => {
    setOpenReativarModal(false);
  };

  /** Validação: Nome, Documento (CPF/CNPJ), E-mail, Tipo de Usuário. Login = e-mail no cadastro. Telefone opcional. Dados complementares para Associado/Parceiro. */
  const validarFormularioUsuario = async () => {
    const err = {};
    const nome = (usuSelecionado.nomeCompleto ?? usuSelecionado.nome ?? "").trim();
    if (!nome) err.nomeCompleto = "Nome completo é obrigatório.";
    const doc = String(usuSelecionado.documento ?? "").replace(/\D/g, "");
    const email = (usuSelecionado.email ?? "").trim();
    if (!email) err.email = "E-mail é obrigatório.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) err.email = "E-mail inválido.";
    const tipoUsuario = (usuSelecionado.tipoUsuario ?? "operador").toLowerCase();
    if (!["responsavel_comercial", "associado", "parceiro", "operador"].includes(tipoUsuario)) {
      err.tipoUsuario = "Tipo de usuário é obrigatório.";
    }
    // Telefone opcional (spec). Login no cadastro usa o e-mail (campo LOGIN removido da UI).
    // Dados complementares para Associado/Parceiro
    const dc = usuSelecionado.dadosComplementares ?? {};
    if (tipoUsuario === "associado" || tipoUsuario === "parceiro") {
      const isCpf = doc.length === 11;
      if (isCpf) {
        if (!dc.estrangeiro && !(dc.rg ?? "").trim()) err.dadosComplementares_rg = "RG é obrigatório para Associado/Parceiro com CPF.";
        if (dc.estrangeiro && !(dc.rne ?? "").trim()) err.dadosComplementares_rne = "RNE é obrigatório para estrangeiro.";
      } else {
        if (!(dc.contratoSocialUrl ?? "").trim()) err.dadosComplementares_contrato = "Contrato Social é obrigatório para CNPJ.";
        if (!(dc.cartaoCnpjUrl ?? "").trim()) err.dadosComplementares_cartao = "Cartão CNPJ é obrigatório para CNPJ.";
        const socios = Array.isArray(dc.socios) ? dc.socios : [{ cpf: "", nome: "" }];
        if (socios.length < 1 || socios.every((s) => !(String(s.cpf ?? "").replace(/\D/g, "")).trim())) {
          err.dadosComplementares_socios = "Cadastre pelo menos um sócio com CPF.";
        } else {
          socios.forEach((s, i) => {
            const cpfNum = String(s.cpf ?? "").replace(/\D/g, "");
            if (cpfNum.length === 11) {
              const nomeSocio = (s.nome ?? "").trim();
              if (!nomeSocio) err[`dadosComplementares_socio_nome_${i}`] = "Nome do sócio é obrigatório.";
            }
          });
        }
      }
    }
    return err;
  };

  //#endregion
  const handleUpdateUsuario = async (e) => {
    e.preventDefault();
    if (salvandoUsuario) return;
    if (!pode(CHAVES_ATUALIZAR_USUARIO)) {
      handleSnackBar("error", "Você não tem permissão para alterar usuários.");
      return;
    }
    setFormErrors({});
    const errors = await validarFormularioUsuario();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      handleSnackBar("error", "Há campos obrigatórios a serem preenchidos para liberar o cadastro. Verifique os campos em destaque.");
      return;
    }
    setSalvandoUsuario(true);
    try {
      const doc = String(usuSelecionado.documento ?? "").replace(/\D/g, "");
      const gruposIds = gruposSelecionadosIds.map((id) => Number(id)).filter((n) => !Number.isNaN(n) && n > 0);
      const herdadasSetUpd = new Set(permissoesHerdadasGrupos);
      const permissoesExtrasUpd = comVisualizarImplicito(
        (permissoesSelecionadas || []).map(chavePermissaoSelecao).filter((id) => id.length > 0),
        arvorePermissoes
      ).filter((id) => !herdadasSetUpd.has(id));

      const payload = {
        ...usuSelecionado,
        nome: usuSelecionado.nomeCompleto ?? usuSelecionado.nome,
        nomeCompleto: usuSelecionado.nomeCompleto ?? usuSelecionado.nome,
        documento: doc || usuSelecionado.documento,
        tipoDocumento: doc.length === 14 ? "cnpj" : "cpf",
        tipoUsuario: usuSelecionado.tipoUsuario ?? "operador",
        dadosComplementares: usuSelecionado.dadosComplementares ?? undefined,
        niveisAcesso: niveisSelecionados,
        idNivelAssociacao: niveisAssociacaoUsuarioIds[0] ?? null,
        idsNiveisAssociacao: niveisAssociacaoUsuarioIds,
        gruposIds,
        idGrupoUsuario: gruposIds.length > 0 ? gruposIds[0] : null,
        dtExpiracao: dtExpiracaoParaApi(usuSelecionado.dtExpiracao),
        permissoesExtras: permissoesExtrasUpd,
        idAssociado: usuSelecionado.vinculo?.id ?? null,
        ...(usuSelecionado.senhaAdmin?.trim() ? { senha: usuSelecionado.senhaAdmin.trim() } : {}),
      };
      const response = await atualizarUsuario(payload);
      handleSnackBar("sucess", response.mensagem);
      setUsuSelecionado((prev) => ({ ...prev, senhaAdmin: "" }));
      await aguardarFeedbackSalvamento();
      sincronizarListaAposSalvar();
    } catch (error) {
      handleSnackBar("error", getErrorMessage(error));
    } finally {
      setSalvandoUsuario(false);
    }
  };

  const handleInsertUsuario = async (e) => {
    e.preventDefault();
    if (salvandoUsuario) return;
    if (!pode(CHAVES_CRIAR_USUARIO)) {
      handleSnackBar("error", "Você não tem permissão para cadastrar usuários.");
      return;
    }
    setFormErrors({});
    const errors = await validarFormularioUsuario();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      handleSnackBar("error", "Há campos obrigatórios a serem preenchidos para liberar o cadastro. Verifique os campos em destaque.");
      return;
    }
    setSalvandoUsuario(true);
    try {
      usuSelecionado.senha = usuSelecionado.senhaAdmin?.trim() || await generateRandomPassword(10);
      const doc = String(usuSelecionado.documento ?? "").replace(/\D/g, "");
      const gruposIds = gruposSelecionadosIds.map((id) => Number(id)).filter((n) => !Number.isNaN(n) && n > 0);
      const idGrupo = gruposIds[0];
      const emailTrim = (usuSelecionado.email ?? "").trim();
      const herdadasSet = new Set(permissoesHerdadasGrupos);
      const permissoesExtras = comVisualizarImplicito(
        (permissoesSelecionadas || []).map(chavePermissaoSelecao).filter((id) => id.length > 0),
        arvorePermissoes
      ).filter((id) => !herdadasSet.has(id));

      const usuarioPayload = {
        ...usuSelecionado,
        nome: usuSelecionado.nomeCompleto ?? usuSelecionado.nome,
        nomeCompleto: usuSelecionado.nomeCompleto ?? usuSelecionado.nome,
        login: emailTrim,
        idGrupoUsuario: idGrupo ?? null,
        documento: doc || undefined,
        tipoDocumento: doc.length === 14 ? "cnpj" : "cpf",
        tipoUsuario: usuSelecionado.tipoUsuario ?? "operador",
        dadosComplementares: usuSelecionado.dadosComplementares ?? undefined,
        niveisAcesso: niveisSelecionados,
        idNivelAssociacao: niveisAssociacaoUsuarioIds[0] ?? null,
        idsNiveisAssociacao: niveisAssociacaoUsuarioIds,
        ativo: usuSelecionado.ativo !== false,
        dtExpiracao: dtExpiracaoParaApi(usuSelecionado.dtExpiracao),
        permissoesExtras,
        idAssociado: usuSelecionado.vinculo?.id ?? null,
      };
      const response = await criarUsuarioGerenciamento(usuarioPayload, gruposIds);
      const idUsuario = response?.idUsuario ?? response?.data?.idUsuario;
      if (idUsuario && usuSelecionado.email) {
        try {
          await enviarTokenRedefinicaoDeSenha({
            email: usuSelecionado.email,
            login: emailTrim,
          });
        } catch {
          // e-mail opcional após criar
        }
      }
      handleSnackBar("sucess", response?.mensagem ?? "Cadastro realizado com sucesso!");
      if (idUsuario) {
        setUsuSelecionado((prev) => ({
          ...prev,
          id: idUsuario,
          idUsuario,
          id_usuario: idUsuario,
          senhaAdmin: "",
        }));
      } else {
        setUsuSelecionado((prev) => ({ ...prev, senhaAdmin: "" }));
      }
      await aguardarFeedbackSalvamento();
      sincronizarListaAposSalvar();
    } catch (error) {
      handleSnackBar("error", getErrorMessage(error));
    } finally {
      setSalvandoUsuario(false);
    }
  };

  const handlePermissoes = (_, value) => {
    setPermissoesSelecionadas(value);
  };

  const handleUpdateAtivacaoUsuario = async (ativo) => {
    if (!pode(CHAVES_ATUALIZAR_USUARIO)) {
      handleSnackBar("error", "Você não tem permissão para ativar ou desativar usuários.");
      return;
    }
    try {
      const response = await atualizarAtivacaoUsuario(
        usuSelecionado.idUsuario,
        ativo
      );
      handleSnackBar("sucess", response.mensagem);
      getData();
    } catch (error) {
      handleSnackBar("error", getErrorMessage(error));
    }
  };
  const handleChangePassword = async () => {
    if (!pode(CHAVES_ATUALIZAR_USUARIO)) {
      handleSnackBar("error", "Você não tem permissão para redefinir senha de outros usuários.");
      return;
    }
    setSendingPasswordEmail(true);
    try {
      const response = await enviarTokenRedefinicaoDeSenha({
        email: usuSelecionado.email,
        login: (usuSelecionado.login ?? usuSelecionado.email ?? "").trim(),
      });
      handleSnackBar("sucess", response?.mensagem ?? "E-mail enviado com sucesso!");
      setOpenPasswordModal(false);
    } catch (error) {
      handleSnackBar("error", getErrorMessage(error));
    } finally {
      setSendingPasswordEmail(false);
    }
  };

  const handleSnackBar = (type, msg = "") => {
    switch (type) {
      case "error":
        setSnackBar((prev) => ({ ...prev, error: true, sucess: false, msg }));
        break;

      case "sucess":
        setSnackBar((prev) => ({ ...prev, error: false, sucess: true, msg }));
        break;

      case "close":
        setSnackBar((prev) => ({ ...prev, error: false, sucess: false, msg: "" }));
        break;
    }
  };

  const handleConsultarCnpjReceita = async () => {
    const doc = String(usuSelecionado.documento ?? "").replace(/\D/g, "");
    if (doc.length !== 14) {
      handleSnackBar("error", "Informe um CNPJ completo (14 dígitos) para consultar na Receita Federal.");
      return;
    }
    setLoadingCnpjConsulta(true);
    try {
      const res = await consultarCNPJUsuario(doc);
      const data = res?.dados ?? res;
      const razao = String(data.razao_social || data.nome || "").trim();
      const emailApi = data.email != null ? String(data.email).trim() : "";
      const telDigits = data.telefone1 != null ? String(data.telefone1).replace(/\D/g, "").slice(0, 11) : "";
      setUsuSelecionado((prev) => {
        const telAtual = String(prev.telefone ?? "").replace(/\D/g, "");
        const emailAtual = String(prev.email ?? "").trim();
        return {
          ...prev,
          nomeCompleto: razao || prev.nomeCompleto,
          nome: razao || prev.nome,
          ...(telDigits && !telAtual ? { telefone: telDigits } : {}),
          ...(emailApi && !emailAtual ? { email: emailApi } : {}),
        };
      });
      handleSnackBar("sucess", "Dados obtidos na Receita Federal (CNPJá).");
    } catch (err) {
      const msg =
        err.response?.data?.erro || err.message || "Erro ao consultar CNPJ. Verifique a api-autenticacao e o token CNPJá.";
      handleSnackBar("error", msg);
    } finally {
      setLoadingCnpjConsulta(false);
    }
  };

  // const debouncedHandleChange = debounce(handleSearchByText, 1000); // Debounce por 1 segundo

  const cardStyle = {
    py: 2,
    px: 2.5,
    display: "flex",
    alignItems: "center",
    gap: 2,
    borderRadius: "8px",
    border: "1px solid #e8ecf0",
    bgcolor: "#ffffff",
    boxShadow: "none",
    height: "100%",
    minHeight: 80,
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      borderColor: "#c5cdd8",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
  };

  const iconBoxStyle = (bg, color) => ({
    width: 44,
    height: 44,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: bg,
    color: color,
    flexShrink: 0,
  });

  const summaryCards = (
    <>
      <Paper elevation={0} sx={cardStyle}>
        <Box sx={iconBoxStyle("#e3f2fd", "#1565c0")}>
          <GroupIcon sx={{ fontSize: 24 }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: "1.75rem", fontWeight: 700, lineHeight: 1, color: "#1b3a5f" }}>{stats.total}</Typography>
          <Typography sx={{ color: "#757575", fontSize: "0.75rem", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mt: 0.25 }}>TOTAL</Typography>
        </Box>
      </Paper>
      <Paper elevation={0} sx={cardStyle}>
        <Box sx={iconBoxStyle("#e8f5e9", "#2e7d32")}>
          <CheckCircleIcon sx={{ fontSize: 24 }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: "1.75rem", fontWeight: 700, lineHeight: 1, color: "#1b3a5f" }}>{stats.ativos}</Typography>
          <Typography sx={{ color: "#757575", fontSize: "0.75rem", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mt: 0.25 }}>ATIVOS</Typography>
        </Box>
      </Paper>
      <Paper elevation={0} sx={cardStyle}>
        <Box sx={iconBoxStyle("#ffebee", "#c62828")}>
          <CancelIcon sx={{ fontSize: 24 }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: "1.75rem", fontWeight: 700, lineHeight: 1, color: "#1b3a5f" }}>{stats.inativos}</Typography>
          <Typography sx={{ color: "#757575", fontSize: "0.75rem", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mt: 0.25 }}>INATIVOS</Typography>
        </Box>
      </Paper>
    </>
  );

  const autocompleteSx = {
    minWidth: 0,
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": { borderColor: "divider" },
    },
    "& .MuiInputLabel-root": {
      color: "#3c4043",
      fontSize: "0.875rem",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#3c4043",
    },
  };

  const customFilters = (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, minmax(0, 1fr))",
          md: podeGerenciarNiveisAssociacao
            ? "repeat(3, minmax(0, 1fr))"
            : "repeat(4, minmax(0, 1fr))",
          lg: podeGerenciarNiveisAssociacao
            ? "repeat(5, minmax(130px, 1fr)) minmax(260px, 1.4fr) auto"
            : "repeat(4, minmax(145px, 1fr)) minmax(300px, 1.6fr) auto",
        },
        alignItems: "center",
        gap: 1,
        flex: 1,
        width: "100%",
      }}
    >
      <Autocomplete
        size="small"
        value={filterStatus}
        onChange={(_, newValue) => setFilterStatus(newValue || { value: "Todos os Status" })}
        options={optionsFilterStatus}
        getOptionLabel={(opt) => opt?.value ?? ""}
        isOptionEqualToValue={(a, b) => a?.value === b?.value}
        renderInput={(params) => <TextField {...params} label="Todos os Status" />}
        sx={autocompleteSx}
      />
      <Autocomplete
        size="small"
        value={filterTipo}
        onChange={(_, newValue) => setFilterTipo(newValue || { value: "Todos os Tipos", apiValue: null })}
        options={optionsFilterTipo}
        getOptionLabel={(opt) => opt?.value ?? ""}
        isOptionEqualToValue={(a, b) => a?.value === b?.value && a?.apiValue === b?.apiValue}
        renderInput={(params) => <TextField {...params} label="Tipo de usuário" />}
        sx={autocompleteSx}
      />
      <Autocomplete
        size="small"
        value={filterGrupo}
        onChange={(_, newValue) => setFilterGrupo(newValue || { value: "Todos os Grupos", id: null })}
        options={optionsGrupoCatalogo}
        getOptionLabel={(opt) => opt?.value ?? ""}
        isOptionEqualToValue={(a, b) => a?.id === b?.id && a?.value === b?.value}
        renderInput={(params) => <TextField {...params} label="Grupo de acesso" />}
        sx={autocompleteSx}
      />
      {podeGerenciarNiveisAssociacao ? (
        <Autocomplete
          size="small"
          value={filterNivelAssociacao}
          onChange={(_, newValue) => setFilterNivelAssociacao(newValue || { value: "Todos os Níveis", id: null })}
          options={optionsFilterNivelAssociacao}
          getOptionLabel={(opt) => opt?.value ?? ""}
          isOptionEqualToValue={(a, b) => a?.id === b?.id && a?.value === b?.value}
          renderInput={(params) => <TextField {...params} label="Nível de acesso" />}
          sx={autocompleteSx}
        />
      ) : null}
      <Autocomplete
        size="small"
        value={filterAssociado}
        onChange={(_, newValue) => setFilterAssociado(newValue || { value: "Todos os Associados", id: null })}
        options={optionsAssociadoCatalogo}
        getOptionLabel={(opt) => opt?.value ?? ""}
        isOptionEqualToValue={(a, b) => a?.id === b?.id && a?.value === b?.value}
        renderInput={(params) => <TextField {...params} label="Associado / empresa" />}
        sx={autocompleteSx}
      />
      <TextField
        size="small"
        placeholder="Buscar por nome, e-mail, CPF ou CNPJ"
        value={searchInput}
        onChange={(e) => {
          setSearchInput(e.target.value);
          debouncedSearch(e.target.value);
        }}
        sx={{ 
          minWidth: 0,
          width: "100%",
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
          "& .MuiInputBase-input::placeholder": {
            color: "#3c4043",
            opacity: 1,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#3c4043" }} />
            </InputAdornment>
          ),
        }}
      />
      {podeExibirBotaoNovoUsuario ? (
        <Button
          variant="contained"
          size="small"
          startIcon={<PersonAddIcon />}
          onClick={() => handleOpenEditModal(null)}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            bgcolor: "primary.main",
            minHeight: 40,
            whiteSpace: "nowrap",
            px: 2,
          }}
        >
          Novo Usuário
        </Button>
      ) : null}
    </Box>
  );

  /* Tela cheia Editar/Cadastrar Usuário (conforme protótipo: mesma área da lista) */
  return (
    <>
      {!openEditModal && (
        <>
          <TableCard
            iconHeader={<GroupIcon sx={{ fontSize: 32, color: "#1b3a5f" }} />}
            titleHeader={<Typography variant="h5" fontWeight={700} sx={{ color: "#1b3a5f", fontSize: "1.625rem", letterSpacing: "-0.3px" }}>Usuários</Typography>}
            headerSx={{ alignItems: "center", padding: "20px 24px 14px" }}
            handleDebounce={handleSearchByText}
            data={data}
            setData={setData}
            columns={columns}
            columnWidths={usuariosTableColumnWidths}
            tableMinWidth={usuariosTableMinWidth}
            stickyActions={true}
            textHeaderCard="nome"
            temInsert={false}
            customFilters={customFilters}
            customFiltersFullWidth={true}
            contentAboveTable={summaryCards}
            contentAboveTableGrid={true}
            contentAboveTableGridCols={3}
            contentAboveTableBg="#f5f5f5"
            hideViewToggle={true}
            loading={loadingLista}
            serverPagination={{
              total: serverTotal,
              page: catalogPage,
              rowsPerPage: catalogPerPage,
              onPageChange: (p) => fetchCatalog({ page: p, perPage: catalogPerPage }),
              onRowsPerPageChange: (n) => fetchCatalog({ page: 1, perPage: n }),
            }}
          />
          <ConfirmDialog
            open={openModal}
            onClose={handleCloseModal}
            onClickSim={() => {
              handleUpdateAtivacaoUsuario(false);
              handleCloseModal();
            }}
            title="Desativar Usuário"
            text={`Tem certeza que deseja desativar o usuário "${usuSelecionado.nomeCompleto || usuSelecionado.login || ""}"? Ele perderá acesso ao sistema imediatamente.`}
            confirmLabel="Confirmar"
            confirmVariant="error"
          />
          <ConfirmDialog
            open={openReativarModal}
            onClose={handleCloseReativarModal}
            onClickSim={() => {
              handleUpdateAtivacaoUsuario(true);
              handleCloseReativarModal();
            }}
            text={`Você tem certeza que gostaria de reativar o usuário ${usuSelecionado.nomeCompleto || usuSelecionado.email || usuSelecionado.login}?`}
          />
        </>
      )}

      {openEditModal && (
        <>
          <Loading loading={salvandoUsuario} overlay={true} />
          <form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              if (modalUsuarioSomenteLeitura) return;
              if (isEdicaoUsuarioExistente(usuSelecionado)) handleUpdateUsuario(e);
              else handleInsertUsuario(e);
            }}
          >
            <Box sx={{ margin: "0 2rem", maxWidth: "100%", bgcolor: "#f5f7fa", borderRadius: "12px", p: 2, minHeight: "100%", "@media (max-width: 780px)": { margin: "0 1rem", p: 2 } }}>

        {/* Card externo: organiza breadcrumb e conteúdo no padrão da tela de grupos */}
        <Box sx={{
          bgcolor: "#f5f7fa",
          borderRadius: "12px",
          overflow: "visible",
          mb: 2,
        }}>

        {/* Breadcrumb */}
        <Box sx={{ bgcolor: "#ffffff", border: "1px solid #e0e0e0", borderRadius: "12px", px: 3, py: 1.25, mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <MuiLink
            component="button"
            type="button"
            onClick={() => setOpenEditModal(false)}
            underline="hover"
            sx={{ fontSize: 13, color: "#1a73e8", fontWeight: 400, cursor: "pointer", background: "none", border: "none", p: 0 }}
          >
            Usuários
          </MuiLink>
          <Typography sx={{ fontSize: 13, color: "#9aa0a6", mx: 0.25 }}>›</Typography>
          <Typography sx={{ fontSize: 13, color: "#5f6368" }}>
            {modalUsuarioSomenteLeitura
              ? "Visualizar Usuário"
              : isEdicaoUsuarioExistente(usuSelecionado)
                ? "Editar Usuário"
                : "Cadastrar Usuário"}
          </Typography>
        </Box>

        {/* Card pai: título e conteúdo */}
        <Box sx={{
          bgcolor: "transparent",
          borderRadius: 0,
          border: "none",
          boxShadow: "none",
          overflow: "visible",
        }}>

        {/* Título */}
        <Box sx={{ bgcolor: "#f5f7fa", px: 0, py: 1.5, display: "flex", alignItems: "center", gap: 1.25 }}>
          {modalUsuarioSomenteLeitura ? (
            <Visibility sx={{ color: "#18316e", fontSize: 26 }} />
          ) : isEdicaoUsuarioExistente(usuSelecionado) ? (
            <Edit sx={{ color: "#18316e", fontSize: 26 }} />
          ) : (
            <PersonAddIcon sx={{ color: "#18316e", fontSize: 28 }} />
          )}
          <Typography variant="h5" fontWeight={700} sx={{ color: "#18316e", fontSize: { xs: "1.25rem", md: "1.625rem" }, letterSpacing: "-0.3px" }}>
            {modalUsuarioSomenteLeitura
              ? "Visualizar Usuário"
              : isEdicaoUsuarioExistente(usuSelecionado)
                ? "Editar Usuário"
                : "Cadastrar Usuário"}
          </Typography>
        </Box>

        {/* Conteúdo interno com fundo #f5f7fa */}
        <Box sx={{ bgcolor: "#f5f7fa", px: 0, pt: 1, pb: 2 }}>

        <ConfirmDialog
          open={openModal}
          onClose={handleCloseModal}
          onClickSim={() => {
            handleUpdateAtivacaoUsuario(false);
            handleCloseModal();
          }}
          title="Desativar Usuário"
          text={`Tem certeza que deseja desativar o usuário "${usuSelecionado.nomeCompleto || usuSelecionado.login || ""}"? Ele perderá acesso ao sistema imediatamente.`}
          confirmLabel="Confirmar"
          confirmVariant="error"
        />

        <ConfirmDialog
          open={openReativarModal}
          onClose={handleCloseReativarModal}
          onClickSim={() => {
            handleUpdateAtivacaoUsuario(true);
            handleCloseReativarModal();
          }}
          text={`Você tem certeza que gostaria de reativar o usuário ${usuSelecionado.nomeCompleto || usuSelecionado.email || usuSelecionado.login}?`}
        />

        <fieldset
          disabled={modalUsuarioSomenteLeitura || salvandoUsuario}
          style={{ border: "none", margin: 0, padding: 0, minWidth: 0 }}
        >
        {/* Card Dados do Usuário */}
        <Paper variant="outlined" sx={{ mb: 2, borderRadius: 2, bgcolor: "#fff", border: "1px solid #e0e0e0", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", overflow: "hidden" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, py: 1.5, bgcolor: "#fafafa", borderBottom: "1px solid #e0e0e0" }}>
            <WorkOutline sx={{ color: "#18316e", fontSize: 20 }} />
            <Typography variant="subtitle1" fontWeight={600} color="text.primary">Dados do Usuário</Typography>
          </Box>
          <Box sx={{ p: 2 }}>
          {(grupoTecnico || podeGerenciarNiveisAssociacao) ? (
            /* ── SuperAdmin: 3 + 3 + 4 ── */
            <>
              {/* SA Linha 1: Nome Completo, CPF/CNPJ, E-mail */}
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2, alignItems: "start" }}>
                <TextField
                  size="small"
                  label="NOME COMPLETO"
                  value={usuSelecionado.nomeCompleto ?? usuSelecionado.nome ?? ""}
                  fullWidth
                  required
                  error={!!formErrors.nomeCompleto}
                  helperText={formErrors.nomeCompleto}
                  onChange={(e) => setUsuSelecionado({ ...usuSelecionado, nomeCompleto: e.target.value, nome: e.target.value })}
                  inputProps={{ "data-only": "letters" }}
                />
                <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0 }}>
                  <Box sx={{ display: "flex", alignItems: "stretch", gap: 1, width: "100%", "& .MuiToggleButtonGroup-root": { flexShrink: 0 }, "& .MuiTextField-root": { flex: 1, minWidth: 0 } }}>
                    <ToggleButtonGroup value={tipoDocumento} exclusive onChange={(_, newVal) => { if (newVal == null) return; setTipoDocumento(newVal); setUsuSelecionado({ ...usuSelecionado, documento: null }); }} size="small" sx={{ "& .MuiToggleButton-root": { px: 1.5, py: 0.75 } }}>
                      <ToggleButton value="cpf" aria-label="CPF">CPF</ToggleButton>
                    </ToggleButtonGroup>
                    <TextField size="small" label={tipoDocumento === "cnpj" ? "CNPJ" : "CPF"} value={formatarDocumento(usuSelecionado.documento) || ""} required error={!!formErrors.documento} helperText={formErrors.documento || ""} placeholder={tipoDocumento === "cnpj" ? "00.000.000/0000-00" : "000.000.000-00"} inputProps={{ maxLength: tipoDocumento === "cnpj" ? 18 : 14 }} onChange={(e) => { const raw = e.target.value.replace(/\D/g, ""); const max = tipoDocumento === "cnpj" ? 14 : 11; setUsuSelecionado({ ...usuSelecionado, documento: raw.slice(0, max) || null }); }} sx={{ flex: 1, minWidth: 0 }} InputProps={tipoDocumento === "cnpj" ? { endAdornment: (<InputAdornment position="end"><Tooltip title="Consultar CNPJ na Receita Federal (CNPJá)" placement="top" arrow><span><IconButton size="small" onClick={handleConsultarCnpjReceita} disabled={loadingCnpjConsulta || String(usuSelecionado.documento ?? "").replace(/\D/g, "").length !== 14} aria-label="Consultar CNPJ na Receita Federal" sx={{ bgcolor: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta ? "#1a73e8" : "transparent", color: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta ? "#fff" : "#bdbdbd", borderRadius: "6px", width: 28, height: 28, transition: "all 0.2s", "&:hover": { bgcolor: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta ? "#1557b0" : "transparent" }, "&.Mui-disabled": { bgcolor: "transparent", color: "#bdbdbd" } }}>{loadingCnpjConsulta ? <CircularProgress color="inherit" size={16} /> : <SearchIcon sx={{ fontSize: 18 }} />}</IconButton></span></Tooltip></InputAdornment>) } : undefined} />
                  </Box>
                </Box>
                <TextField size="small" label="E-MAIL" value={usuSelecionado.email ?? ""} fullWidth required error={!!formErrors.email} helperText={formErrors.email} type="email" autoComplete="off" onChange={(e) => setUsuSelecionado({ ...usuSelecionado, email: e.target.value })} />
              </Box>
              {/* SA Linha 2: Telefone, Tipo de Usuário, Vínculo */}
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2, mt: 2, alignItems: "start" }}>
                <TextField size="small" label="TELEFONE" value={(() => { const t = String(usuSelecionado.telefone ?? "").replace(/\D/g, ""); if (t.length <= 2) return t ? `(${t}` : ""; if (t.length <= 7) return `(${t.slice(0, 2)}) ${t.slice(2)}`; return `(${t.slice(0, 2)}) ${t.slice(2, 7)}-${t.slice(7, 11)}`; })()} fullWidth placeholder="(00) 00000-0000" inputProps={{ maxLength: 15 }} onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 11); setUsuSelecionado({ ...usuSelecionado, telefone: v || "" }); }} />
                <Autocomplete size="small" options={[{ value: "responsavel_comercial", label: "Responsável Comercial" }, { value: "associado", label: "Associado" }, { value: "parceiro", label: "Parceiro" }, { value: "operador", label: "Operador" }]} getOptionLabel={(opt) => opt?.label ?? ""} value={(() => { const t = (usuSelecionado.tipoUsuario ?? "operador").toLowerCase(); const opts = [{ value: "responsavel_comercial", label: "Responsável Comercial" }, { value: "associado", label: "Associado" }, { value: "parceiro", label: "Parceiro" }, { value: "operador", label: "Operador" }]; return opts.find((o) => o.value === t) ?? opts[4]; })()} onChange={(_, newVal) => setUsuSelecionado({ ...usuSelecionado, tipoUsuario: newVal?.value ?? "operador" })} renderInput={(params) => (<TextField {...params} label="TIPO DE USUÁRIO" required error={!!formErrors.tipoUsuario} helperText={formErrors.tipoUsuario} />)} />
                <Autocomplete size="small" options={[...(usuSelecionado.vinculo?.id != null && !optionsVinculos.some((o) => o.id === usuSelecionado.vinculo.id) ? [{ value: usuSelecionado.vinculo.nome ?? `Associado #${usuSelecionado.vinculo.id}`, id: usuSelecionado.vinculo.id }] : []), ...optionsVinculos]} getOptionLabel={(opt) => opt?.value ?? ""} isOptionEqualToValue={(option, value) => option.id != null && value?.id != null ? option.id === value.id : option.value === value?.value} value={(() => { const id = usuSelecionado.vinculo?.id; if (id == null) return null; return optionsVinculos.find((o) => o.id === id) ?? { value: usuSelecionado.vinculo.nome ?? `Associado #${id}`, id }; })()} onChange={(_, newValue) => setUsuSelecionado({ ...usuSelecionado, vinculo: newValue ? { nome: newValue.value, id: newValue.id ?? null } : null })} renderInput={(params) => (<TextField {...params} label="VÍNCULO" placeholder="Selecione..." />)} />
              </Box>
              {/* SA Linha 3: Data Expiração | Definir Senha | Usuário Ativo + Redefinir Senha */}
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2, mt: 2, alignItems: "center" }}>
                <Tooltip title="Deixe em branco para acesso permanente." placement="top" arrow>
                  <Box>
                    <GenericDatePicker label="DATA DE EXPIRAÇÃO" value={usuSelecionado.dtExpiracao} onChange={(e) => setUsuSelecionado({ ...usuSelecionado, dtExpiracao: e })} placeholder="dd/mm/aaaa" />
                  </Box>
                </Tooltip>
                {superAdmin && (
                <Tooltip title={usuSelecionado.idUsuario ? "Deixe em branco para manter a senha atual." : ""} placement="top" arrow>
                  <Box>
                    <TextField
                      size="small"
                      label="DEFINIR SENHA"
                      placeholder={usuSelecionado.idUsuario ? "••••••••" : ""}
                      type={showAdminSenha ? "text" : "password"}
                      value={usuSelecionado.senhaAdmin ?? ""}
                      autoComplete="new-password"
                      onChange={(e) => setUsuSelecionado({ ...usuSelecionado, senhaAdmin: e.target.value })}
                      fullWidth
                      InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton size="small" onClick={() => setShowAdminSenha((v) => !v)}>{showAdminSenha ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}</IconButton></InputAdornment>) }}
                    />
                  </Box>
                </Tooltip>
                )}
                <Box sx={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  flexWrap: "nowrap", height: 40, px: 1.5,
                  border: "1px solid rgba(0,0,0,0.23)", borderRadius: "4px",
                  "&:hover": { borderColor: "rgba(0,0,0,0.87)" },
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>Usuário Ativo</Typography>
                    <IfPermissao anyOf={modoEdicaoUsuarioModal ? CHAVES_ATUALIZAR_USUARIO : CHAVES_CRIAR_USUARIO} fallback={<Switch checked={usuSelecionado.ativo !== false} disabled color="success" />}>
                      <Switch checked={usuSelecionado.ativo !== false} onChange={(e) => setUsuSelecionado({ ...usuSelecionado, ativo: e.target.checked })} color="success" />
                    </IfPermissao>
                  </Box>
                  {isEdicaoUsuarioExistente(usuSelecionado) ? (
                    <IfPermissao anyOf={CHAVES_ATUALIZAR_USUARIO} fallback={null}>
                      <Button variant="outlined" size="small" startIcon={<Lock sx={{ color: "#18316e" }} />} onClick={handleOpenPasswordModal} sx={{ borderColor: "#bdbdbd", color: "text.secondary", whiteSpace: "nowrap", flexShrink: 0 }}>
                        {loading ? <CircularProgress size={20} color="inherit" /> : "Redefinir Senha"}
                      </Button>
                    </IfPermissao>
                  ) : null}
                </Box>
              </Box>
            </>
          ) : (
            /* ── Não-SuperAdmin: layout original 4 + 4 ── */
            <>
              {/* Grid único 4 colunas — linhas 1 e 2 compartilham o mesmo grid para colunas consistentes */}
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr 1fr" }, gap: 2, alignItems: "start" }}>
            <TextField
              size="small"
              label="NOME COMPLETO"
              value={usuSelecionado.nomeCompleto ?? usuSelecionado.nome ?? ""}
              fullWidth
              required
              error={!!formErrors.nomeCompleto}
              helperText={formErrors.nomeCompleto}
              onChange={(e) => setUsuSelecionado({ ...usuSelecionado, nomeCompleto: e.target.value, nome: e.target.value })}
              inputProps={{ "data-only": "letters" }}
            />
            <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  gap: 1,
                  width: "100%",
                  "& .MuiToggleButtonGroup-root": { flexShrink: 0 },
                  "& .MuiTextField-root": { flex: 1, minWidth: 0 },
                }}
              >
                <ToggleButtonGroup
                  value={tipoDocumento}
                  exclusive
                  onChange={(_, newVal) => {
                    if (newVal == null) return;
                    setTipoDocumento(newVal);
                    setUsuSelecionado({ ...usuSelecionado, documento: null });
                  }}
                  size="small"
                  sx={{ "& .MuiToggleButton-root": { px: 1.5, py: 0.75 } }}
                >
                  <ToggleButton value="cpf" aria-label="CPF">CPF</ToggleButton>
                </ToggleButtonGroup>
                <TextField
                  size="small"
                  label={tipoDocumento === "cnpj" ? "CNPJ" : "CPF"}
                  value={formatarDocumento(usuSelecionado.documento) || ""}
                  required
                  error={!!formErrors.documento}
                  helperText={
                    formErrors.documento || ""
                  }
                  placeholder={tipoDocumento === "cnpj" ? "00.000.000/0000-00" : "000.000.000-00"}
                  inputProps={{ maxLength: tipoDocumento === "cnpj" ? 18 : 14 }}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, "");
                    const max = tipoDocumento === "cnpj" ? 14 : 11;
                    setUsuSelecionado({ ...usuSelecionado, documento: raw.slice(0, max) || null });
                  }}
                  sx={{ flex: 1, minWidth: 0 }}
                  InputProps={
                    tipoDocumento === "cnpj"
                      ? {
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title="Consultar CNPJ na Receita Federal (CNPJá)" placement="top" arrow>
                                <span>
                                  <IconButton
                                    size="small"
                                    onClick={handleConsultarCnpjReceita}
                                    disabled={
                                      loadingCnpjConsulta ||
                                      String(usuSelecionado.documento ?? "").replace(/\D/g, "").length !== 14
                                    }
                                    aria-label="Consultar CNPJ na Receita Federal"
                                    sx={{
                                      bgcolor: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta
                                        ? "#1a73e8"
                                        : "transparent",
                                      color: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta
                                        ? "#fff"
                                        : "#bdbdbd",
                                      borderRadius: "6px",
                                      width: 28,
                                      height: 28,
                                      transition: "all 0.2s",
                                      "&:hover": {
                                        bgcolor: String(usuSelecionado.documento ?? "").replace(/\D/g, "").length === 14 && !loadingCnpjConsulta
                                          ? "#1557b0"
                                          : "transparent",
                                      },
                                      "&.Mui-disabled": { bgcolor: "transparent", color: "#bdbdbd" },
                                    }}
                                  >
                                    {loadingCnpjConsulta ? (
                                      <CircularProgress color="inherit" size={16} />
                                    ) : (
                                      <SearchIcon sx={{ fontSize: 18 }} />
                                    )}
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }
                      : undefined
                  }
                />
              </Box>
            </Box>
            <TextField
              size="small"
              label="E-MAIL"
              value={usuSelecionado.email ?? ""}
              fullWidth
              required
              error={!!formErrors.email}
              helperText={formErrors.email}
              type="email"
              autoComplete="off"
              onChange={(e) => setUsuSelecionado({ ...usuSelecionado, email: e.target.value })}
            />
            <TextField
              size="small"
              label="TELEFONE"
              value={(() => {
                const t = String(usuSelecionado.telefone ?? "").replace(/\D/g, "");
                if (t.length <= 2) return t ? `(${t}` : "";
                if (t.length <= 7) return `(${t.slice(0, 2)}) ${t.slice(2)}`;
                return `(${t.slice(0, 2)}) ${t.slice(2, 7)}-${t.slice(7, 11)}`;
              })()}
              fullWidth
              placeholder="(00) 00000-0000"
              inputProps={{ maxLength: 15 }}
              onChange={(e) => {
                const v = e.target.value.replace(/\D/g, "").slice(0, 11);
                setUsuSelecionado({ ...usuSelecionado, telefone: v || "" });
              }}
            />
                <Autocomplete size="small" options={[{ value: "responsavel_comercial", label: "Responsável Comercial" }, { value: "associado", label: "Associado" }, { value: "parceiro", label: "Parceiro" }, { value: "operador", label: "Operador" }]} getOptionLabel={(opt) => opt?.label ?? ""} value={(() => { const t = (usuSelecionado.tipoUsuario ?? "operador").toLowerCase(); const opts = [{ value: "responsavel_comercial", label: "Responsável Comercial" }, { value: "associado", label: "Associado" }, { value: "parceiro", label: "Parceiro" }, { value: "operador", label: "Operador" }]; return opts.find((o) => o.value === t) ?? opts[4]; })()} onChange={(_, newVal) => setUsuSelecionado({ ...usuSelecionado, tipoUsuario: newVal?.value ?? "operador" })} renderInput={(params) => (<TextField {...params} label="TIPO DE USUÁRIO" required error={!!formErrors.tipoUsuario} helperText={formErrors.tipoUsuario} />)} />
                <Autocomplete size="small" options={[...(usuSelecionado.vinculo?.id != null && !optionsVinculos.some((o) => o.id === usuSelecionado.vinculo.id) ? [{ value: usuSelecionado.vinculo.nome ?? `Associado #${usuSelecionado.vinculo.id}`, id: usuSelecionado.vinculo.id }] : []), ...optionsVinculos]} getOptionLabel={(opt) => opt?.value ?? ""} isOptionEqualToValue={(option, value) => option.id != null && value?.id != null ? option.id === value.id : option.value === value?.value} value={(() => { const id = usuSelecionado.vinculo?.id; if (id == null) return null; return optionsVinculos.find((o) => o.id === id) ?? { value: usuSelecionado.vinculo.nome ?? `Associado #${id}`, id }; })()} onChange={(_, newValue) => setUsuSelecionado({ ...usuSelecionado, vinculo: newValue ? { nome: newValue.value, id: newValue.id ?? null } : null })} renderInput={(params) => (<TextField {...params} label="VÍNCULO" placeholder="Selecione..." />)} />
                <Tooltip title="Deixe em branco para acesso permanente." placement="top" arrow>
                  <Box sx={{ width: "100%" }}>
                    <GenericDatePicker label="DATA DE EXPIRAÇÃO" value={usuSelecionado.dtExpiracao} onChange={(e) => setUsuSelecionado({ ...usuSelecionado, dtExpiracao: e })} placeholder="dd/mm/aaaa" />
                  </Box>
                </Tooltip>
                <Box sx={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  flexWrap: "nowrap", height: 40, px: 1.5,
                  border: "1px solid rgba(0,0,0,0.23)", borderRadius: "4px",
                  "&:hover": { borderColor: "rgba(0,0,0,0.87)" },
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>Usuário Ativo</Typography>
                    <IfPermissao anyOf={modoEdicaoUsuarioModal ? CHAVES_ATUALIZAR_USUARIO : CHAVES_CRIAR_USUARIO} fallback={<Switch checked={usuSelecionado.ativo !== false} disabled color="success" />}>
                      <Switch checked={usuSelecionado.ativo !== false} onChange={(e) => setUsuSelecionado({ ...usuSelecionado, ativo: e.target.checked })} color="success" />
                    </IfPermissao>
                  </Box>
                  {isEdicaoUsuarioExistente(usuSelecionado) ? (
                    <IfPermissao anyOf={CHAVES_ATUALIZAR_USUARIO} fallback={null}>
                      <Button variant="outlined" size="small" startIcon={<Lock sx={{ color: "#18316e" }} />} onClick={handleOpenPasswordModal} sx={{ borderColor: "#bdbdbd", color: "text.secondary", whiteSpace: "nowrap", flexShrink: 0 }}>
                        {loading ? <CircularProgress size={20} color="inherit" /> : "Redefinir Senha"}
                      </Button>
                    </IfPermissao>
                  ) : null}
                </Box>
              </Box>
            </>
          )}
          </Box>{/* fim Box p=2.5 */}
        </Paper>

        {/* Dados Complementares — apenas para Associado ou Parceiro */}
        {(() => {
          const tipo = (usuSelecionado.tipoUsuario ?? "operador").toLowerCase();
          const isAssocOuParceiro = tipo === "associado" || tipo === "parceiro";
          if (!isAssocOuParceiro) return null;
          const docLen = String(usuSelecionado.documento ?? "").replace(/\D/g, "").length;
          const isCpf = docLen === 11;
          const dc = usuSelecionado.dadosComplementares ?? { rg: "", estrangeiro: false, passaporte: "", rne: "", contratoSocialUrl: "", cartaoCnpjUrl: "", socios: [{ cpf: "", nome: "" }] };
          const setDc = (patch) => setUsuSelecionado({ ...usuSelecionado, dadosComplementares: { ...dc, ...patch } });
          const updateSocio = (index, field, value) => {
            const socios = [...(dc.socios ?? [{ cpf: "", nome: "" }])];
            if (!socios[index]) socios[index] = { cpf: "", nome: "" };
            socios[index] = { ...socios[index], [field]: value };
            setDc({ socios });
          };
          const addSocio = () => setDc({ socios: [...(dc.socios ?? []), { cpf: "", nome: "" }] });
          const removeSocio = (index) => {
            const socios = (dc.socios ?? []).filter((_, i) => i !== index);
            if (socios.length < 1) socios.push({ cpf: "", nome: "" });
            setDc({ socios });
          };
          return (
            <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: "#fff", border: "1px solid", borderColor: "#eee", boxShadow: "none" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <Tag sx={{ color: "#18316e", fontSize: 20 }} />
                <Typography variant="subtitle1" fontWeight={600} color="text.primary">Dados Complementares</Typography>
              </Box>
              {isCpf ? (
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2 }}>
                  <TextField size="small" label="RG" value={dc.rg ?? ""} fullWidth required={!dc.estrangeiro} error={!!formErrors.dadosComplementares_rg} helperText={formErrors.dadosComplementares_rg} onChange={(e) => setDc({ rg: e.target.value })} />
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">Estrangeiro</Typography>
                    <Switch checked={!!dc.estrangeiro} onChange={(e) => setDc({ estrangeiro: e.target.checked })} size="small" />
                  </Box>
                  {dc.estrangeiro ? (
                    <TextField size="small" label="RNE" value={dc.rne ?? ""} fullWidth required error={!!formErrors.dadosComplementares_rne} helperText={formErrors.dadosComplementares_rne} onChange={(e) => setDc({ rne: e.target.value })} />
                  ) : (
                    <TextField size="small" label="PASSAPORTE" value={dc.passaporte ?? ""} fullWidth error={!!formErrors.dadosComplementares_passaporte} helperText={formErrors.dadosComplementares_passaporte} onChange={(e) => setDc({ passaporte: e.target.value })} />
                  )}
                </Box>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
                    <Box>
                      {dc.contratoSocialUrl ? (
                        <TextField
                          size="small"
                          label="CONTRATO SOCIAL"
                          value={nomeDocumento(dc.contratoSocialNome || dc.contratoSocialUrl.split("/").pop() || dc.contratoSocialUrl, "contrato_social")}
                          fullWidth
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <IconButton size="small" sx={{ color: "#c62828" }} title="Remover contrato social" onClick={() => {
                                const idU = usuSelecionado.idUsuario ?? usuSelecionado.id_usuario;
                                pendingDeleteDocRef.current = async () => {
                                  if (idU && Number(idU) > 0) {
                                    try {
                                      await deleteDocumentoUsuarioTxm220(Number(idU), "contrato_social");
                                      handleSnackBar("sucess", "Contrato social removido.");
                                    } catch (err) {
                                      handleSnackBar("error", getErrorMessage(err));
                                    }
                                  }
                                  setDc({ contratoSocialUrl: "", contratoSocialNome: "" });
                                };
                                setConfirmDeleteDocOpen(true);
                              }}>
                                <Delete fontSize="small" />
                              </IconButton>
                            ),
                          }}
                        />
                      ) : (
                        <Button variant="outlined" size="small" component="label" sx={{ py: 1.5, width: "100%" }}>
                          Contrato Social (PDF, DOC, DOCX)
                          <input
                            type="file"
                            hidden
                            accept=".pdf,.doc,.docx"
                            onChange={async (e) => {
                              const f = e.target.files?.[0];
                              if (!f) return;
                              const idU = usuSelecionado.idUsuario ?? usuSelecionado.id_usuario;
                              if (idU && Number(idU) > 0) {
                                try {
                                  const res = await uploadDocumentoUsuarioTxm220(Number(idU), "contrato_social", f);
                                  const url = res?.url ?? res?.data?.url;
                                  const nomeArquivo = res?.nome_arquivo ?? res?.data?.nome_arquivo ?? f.name;
                                  setDc({ contratoSocialUrl: url || f.name, contratoSocialNome: nomeArquivo });
                                  if (url) handleSnackBar("sucess", "Contrato social enviado.");
                                } catch (err) {
                                  handleSnackBar("error", getErrorMessage(err));
                                }
                              } else {
                                setDc({ contratoSocialUrl: f.name, contratoSocialNome: f.name });
                              }
                              e.target.value = "";
                            }}
                          />
                        </Button>
                      )}
                    </Box>
                    <Box>
                      {dc.cartaoCnpjUrl ? (
                        <TextField
                          size="small"
                          label="CARTÃO CNPJ"
                          value={nomeDocumento(dc.cartaoCnpjNome || dc.cartaoCnpjUrl.split("/").pop() || dc.cartaoCnpjUrl, "cartao_cnpj")}
                          fullWidth
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <IconButton size="small" sx={{ color: "#c62828" }} title="Remover cartão CNPJ" onClick={() => {
                                const idU = usuSelecionado.idUsuario ?? usuSelecionado.id_usuario;
                                pendingDeleteDocRef.current = async () => {
                                  if (idU && Number(idU) > 0) {
                                    try {
                                      await deleteDocumentoUsuarioTxm220(Number(idU), "cartao_cnpj");
                                      handleSnackBar("sucess", "Cartão CNPJ removido.");
                                    } catch (err) {
                                      handleSnackBar("error", getErrorMessage(err));
                                    }
                                  }
                                  setDc({ cartaoCnpjUrl: "", cartaoCnpjNome: "" });
                                };
                                setConfirmDeleteDocOpen(true);
                              }}>
                                <Delete fontSize="small" />
                              </IconButton>
                            ),
                          }}
                        />
                      ) : (
                        <Button variant="outlined" size="small" component="label" sx={{ py: 1.5, width: "100%" }}>
                          Cartão CNPJ (PDF, JPG, PNG)
                          <input
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={async (e) => {
                              const f = e.target.files?.[0];
                              if (!f) return;
                              const idU = usuSelecionado.idUsuario ?? usuSelecionado.id_usuario;
                              if (idU && Number(idU) > 0) {
                                try {
                                  const res = await uploadDocumentoUsuarioTxm220(Number(idU), "cartao_cnpj", f);
                                  const url = res?.url ?? res?.data?.url;
                                  const nomeArquivo = res?.nome_arquivo ?? res?.data?.nome_arquivo ?? f.name;
                                  setDc({ cartaoCnpjUrl: url || f.name, cartaoCnpjNome: nomeArquivo });
                                  if (url) handleSnackBar("sucess", "Cartão CNPJ enviado.");
                                } catch (err) {
                                  handleSnackBar("error", getErrorMessage(err));
                                }
                              } else {
                                setDc({ cartaoCnpjUrl: f.name, cartaoCnpjNome: f.name });
                              }
                              e.target.value = "";
                            }}
                          />
                        </Button>
                      )}
                    </Box>
                  </Box>
                  {formErrors.dadosComplementares_contrato && <Typography variant="caption" color="error">{formErrors.dadosComplementares_contrato}</Typography>}
                  {formErrors.dadosComplementares_cartao && <Typography variant="caption" color="error">{formErrors.dadosComplementares_cartao}</Typography>}
                  <Typography variant="subtitle2" color="text.secondary">Tabela de Sócios</Typography>
                  <Box sx={{ border: "1px solid", borderColor: "#eee", borderRadius: 1, overflow: "hidden" }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 1, p: 1, bgcolor: "#f5f5f5" }}>
                      <Typography variant="caption" fontWeight={600}>CPF do Sócio</Typography>
                      <Typography variant="caption" fontWeight={600}>Nome Completo</Typography>
                      <span />
                    </Box>
                    {(dc.socios ?? [{ cpf: "", nome: "" }]).map((s, i) => (
                      <Box key={i} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 1, p: 1, alignItems: "center", borderTop: "1px solid", borderColor: "#eee" }}>
                        <TextField size="small" placeholder="000.000.000-00" value={formatarDocumento(s.cpf) || ""} onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 11); updateSocio(i, "cpf", v); }} />
                        <TextField size="small" placeholder="Nome" value={s.nome ?? ""} onChange={(e) => updateSocio(i, "nome", e.target.value)} error={!!formErrors[`dadosComplementares_socio_nome_${i}`]} />
                        {(dc.socios ?? []).length > 1 && <IconButton size="small" onClick={() => removeSocio(i)} sx={{ color: "#c62828" }}><Remove fontSize="small" /></IconButton>}
                      </Box>
                    ))}
                    <Box sx={{ p: 1, borderTop: "1px solid", borderColor: "#eee" }}>
                      <Button size="small" startIcon={<Add />} onClick={addSocio}>Adicionar Sócio</Button>
                    </Box>
                  </Box>
                  {formErrors.dadosComplementares_socios && <Typography variant="caption" color="error">{formErrors.dadosComplementares_socios}</Typography>}
                </Box>
              )}
            </Paper>
          );
        })()}

      {/* Grupos de Acesso + Níveis de acesso + permissões */}
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "0.95fr 1.05fr" }, gap: 2, alignItems: "start", minHeight: 0 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, minHeight: 0, alignSelf: "start", position: { lg: "sticky" }, top: { lg: 16 } }}>
                {/* Card de Grupos de Acesso */}
                <Paper variant="outlined" sx={{ borderRadius: "12px", overflow: "hidden", flex: "0 0 auto", display: "flex", flexDirection: "column", minHeight: { lg: podeGerenciarNiveisAssociacao ? 180 : 420 }, bgcolor: "#fff", border: "1px solid #e0e0e0", boxShadow: "0 2px 8px rgba(0,0,0,0.07)" }}>
                  {/* Header com fundo #fafafa */}
                  <Box sx={{ flexShrink: 0, px: 2, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: "#fafafa", borderBottom: "1px solid #e0e0e0" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <GroupIcon sx={{ color: "#18316e", fontSize: 22 }} />
                      <Typography fontWeight={600} color="text.primary">Grupos de Acesso</Typography>
                    </Box>
                    <Chip
                      label={gruposSelecionadosLabel}
                      size="small"
                      sx={{ bgcolor: "#e3f2fd", color: "#1976d2", fontWeight: 500, borderRadius: "16px" }}
                    />
                  </Box>
                  {/* Faixa azul com colunas */}
                  <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto", px: 2, py: 1, bgcolor: "#18316e" }}>
                    <Typography variant="caption" fontWeight={700} sx={{ color: "#fff", textTransform: "uppercase", letterSpacing: "0.5px" }}>Grupo</Typography>
                    <Typography variant="caption" fontWeight={700} sx={{ color: "#fff", textTransform: "uppercase", letterSpacing: "0.5px" }}>Selecionado</Typography>
                  </Box>
                  <Box sx={{ overflowY: "auto", flex: 1, maxHeight: { xs: 280, lg: podeGerenciarNiveisAssociacao ? 320 : 520 } }}>
                    {gruposListaModal.length === 0 ? (
                      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>Nenhum grupo disponível.</Typography>
                    ) : (
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        {gruposListaModal.map((g) => {
                          const idStr = String(g.id);
                          const selected = gruposSelecionadosIds.map(String).includes(idStr);
                          const disabledRow = !g.ativo && !selected;
                          const bg = COR_ICON_BG_GRUPO[g.cor] || COR_ICON_BG_GRUPO.blue;
                          const fg = COR_ICON_FG_GRUPO[g.cor] || COR_ICON_FG_GRUPO.blue;
                          return (
                            <Box
                              key={idStr}
                              sx={{
                                display: "grid",
                                gridTemplateColumns: "1fr auto",
                                alignItems: "center",
                                px: 2,
                                py: 1.25,
                                borderBottom: "1px solid #e8e8e8",
                                bgcolor: selected ? "#f5f9ff" : "#fff",
                                opacity: g.ativo ? 1 : 0.72,
                                "&:last-child": { borderBottom: "none" },
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
                                <Avatar sx={{ width: 40, height: 40, bgcolor: bg, color: fg }}>
                                  <GroupIcon sx={{ fontSize: 22 }} />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography fontWeight={600} color="text.primary" sx={{ lineHeight: 1.3 }}>
                                    {g.nome}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.25 }}>
                                    {g.nivelAssociacao || "Herança de permissões pelo grupo"}
                                  </Typography>
                                  {g.numPermissoes != null && !Number.isNaN(g.numPermissoes) && (
                                    <Typography variant="caption" color="text.secondary" display="block">
                                      {g.numPermissoes} {g.numPermissoes === 1 ? "permissão" : "permissões"}
                                    </Typography>
                                  )}
                                </Box>
                                <Checkbox
                                  checked={selected}
                                  disabled={modalUsuarioSomenteLeitura || disabledRow}
                                  onChange={() => toggleGrupoModal(idStr)}
                                  size="small"
                                  sx={{ p: 0, mt: -0.25 }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                </Paper>

                {/* Mesmo card de nível de associação usado em Grupos de Acesso. Visível somente para Super Admin. */}
                {podeGerenciarNiveisAssociacao && (
                <Paper variant="outlined" sx={{ borderRadius: "12px", overflow: "hidden", flex: "0 0 auto", display: "flex", flexDirection: "column", bgcolor: "#fff", border: "1px solid #e0e0e0", boxShadow: "0 2px 8px rgba(0,0,0,0.07)" }}>
                  <Box sx={{ flexShrink: 0, px: 2, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: "#fafafa", borderBottom: "1px solid #e0e0e0" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AdminPanelSettings sx={{ color: "#18316e", fontSize: 22 }} />
                      <Typography fontWeight={600} color="text.primary">Nível de Acesso para Associação</Typography>
                    </Box>
                    <Chip
                      label={niveisAssociacaoSelecionadosLabel || "Nenhum selecionado"}
                      size="small"
                      sx={{ bgcolor: "#e3f2fd", color: "#1976d2", fontWeight: 500, borderRadius: "16px" }}
                    />
                  </Box>
                  <Box sx={{ px: 2, py: 2 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: "13px", lineHeight: 1.45 }}>
                      Define quem pode associar usuários a este grupo. Apenas usuários com o nível selecionado (ou superior) poderão atribuir este grupo a outros usuários.
                    </Typography>
                    <Grid container spacing={2}>
                      {niveisAssociacaoOptions.map((nivel, idx) => {
                        const IconComp = NIVEL_ASSOCIACAO_CARD_ICONS[idx % NIVEL_ASSOCIACAO_CARD_ICONS.length];
                        const idNivel = Number(nivel.idNivelAssociacao);
                        const selected = niveisAssociacaoUsuarioIds.map(Number).includes(idNivel);
                        return (
                          <Grid item xs={12} sm={6} key={nivel.chave || idNivel}>
                            <Paper
                              variant="outlined"
                              onClick={() => selecionarNivelAssociacaoUsuario(idNivel)}
                              sx={{
                                p: 2,
                                height: "100%",
                                minHeight: 96,
                                cursor: podeMutarUsuarioNoModal ? "pointer" : "default",
                                border: selected ? "2px solid #1976d2" : "1px solid",
                                borderColor: selected ? "#1976d2" : "#e8e8e8",
                                bgcolor: selected ? "#f5f9ff" : "#fff",
                                borderRadius: 2,
                                opacity: podeMutarUsuarioNoModal ? 1 : 0.72,
                                transition: "border-color 0.2s, background-color 0.2s",
                                "&:hover": podeMutarUsuarioNoModal
                                  ? { borderColor: "#1976d2", bgcolor: "#fafafa" }
                                  : undefined,
                              }}
                            >
                              <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                                <Box sx={{ color: "#18316e", display: "flex", pt: 0.25 }}>
                                  <IconComp sx={{ fontSize: 28 }} />
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography fontWeight={600} color="text.primary" sx={{ lineHeight: 1.3 }}>
                                    {nivel.nome}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, fontSize: "0.8125rem", lineHeight: 1.4 }}>
                                    {nivel.descricao || "—"}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                </Paper>
                )}
              </Box>

              {/* Coluna direita: permissões efetivas (usuarios_permissoes / catálogo). */}
              <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, alignSelf: "start", width: "100%" }}>
                <Paper variant="outlined" sx={{ display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: "12px", bgcolor: "#fff", border: "1px solid #e0e0e0", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", alignSelf: "stretch" }}>
                <Box sx={{ flexShrink: 0, px: 2, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: "#fafafa", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Lock sx={{ color: "#18316e", fontSize: 22 }} />
                    <Typography fontWeight={600} color="text.primary">Permissões do usuário</Typography>
                  </Box>
                  <Chip
                    label={`${totalPermissoesSelecionadasArvore} de ${totalPermissoesArvore}`}
                    size="small"
                    sx={{ bgcolor: "#e3f2fd", color: "#1976d2", fontWeight: 500, borderRadius: "16px" }}
                  />
                </Box>
                <Box sx={{ flexShrink: 0, px: 2, py: 1.25, display: "grid", gridTemplateColumns: { xs: "1fr", sm: "auto 1fr" }, alignItems: "center", gap: 1.5, bgcolor: "#fafafa", borderBottom: "1px solid", borderColor: "#eee" }}>
                  <Box
                    component="span"
                    role="button"
                    tabIndex={arvorePermissoes.length === 0 ? -1 : 0}
                    aria-disabled={arvorePermissoes.length === 0}
                    onClick={() => {
                      if (arvorePermissoes.length === 0) return;
                      alternarTodasPermissoes();
                    }}
                    onKeyDown={(e) => {
                      if (arvorePermissoes.length === 0) return;
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        alternarTodasPermissoes();
                      }
                    }}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.75,
                      justifySelf: "start",
                      px: 1.25,
                      py: 0.55,
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      color: "#555",
                      bgcolor: "#fff",
                      fontSize: "0.8125rem",
                      fontWeight: 500,
                      lineHeight: 1.75,
                      textTransform: "none",
                      cursor: arvorePermissoes.length === 0 ? "default" : "pointer",
                      opacity: arvorePermissoes.length === 0 ? 0.5 : 1,
                      "&:hover": { borderColor: "#999", bgcolor: "#f5f5f5" },
                    }}
                  >
                    {todasPermissoesExpandidas ? <ExpandLess sx={{ fontSize: 18 }} /> : <ExpandMore sx={{ fontSize: 18 }} />}
                    {todasPermissoesExpandidas ? "Recolher todas" : "Expandir todas"}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5, flexWrap: "wrap" }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={400}>
                      {(() => {
                        const total = totalPermissoesSelecionadasArvore;
                        if (total === 0) return "0 permissões selecionadas";
                        const arvoreList = listarPermissoesDaArvore(arvorePermissoes);
                        const herdadas = arvoreList.filter(p => p?.chave && permissoesHerdadasGrupos.includes(p.chave)).length;
                        const individuais = total - herdadas;
                        const parts = [];
                        if (herdadas > 0) parts.push(`${herdadas} herdada${herdadas > 1 ? 's' : ''}`);
                        if (individuais > 0) parts.push(`${individuais} individual${individuais > 1 ? 'is' : ''}`);
                        return `${total} permissões: ${parts.join(' + ')}`;
                      })()}
                    </Typography>
                    <IfPermissao anyOf={modoEdicaoUsuarioModal ? CHAVES_ATUALIZAR_USUARIO : CHAVES_CRIAR_USUARIO} fallback={null}>
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<FilterList sx={{ fontSize: 18, color: "#666" }} />}
                        onClick={() => setPermissoesSelecionadas([])}
                        sx={{
                          borderColor: "#ddd",
                          color: "#555",
                          bgcolor: "#fff",
                          textTransform: "none",
                          "&:hover": { borderColor: "#999", bgcolor: "#f5f5f5" },
                        }}
                      >
                        Limpar
                      </Button>
                    </IfPermissao>
                  </Box>
                </Box>
                <Box sx={{ overflowX: "hidden", px: 2, py: 1.5, borderTop: "1px solid", borderColor: "#eee" }}>
                  {arvorePermissoes.length > 0 ? (
                    arvorePermissoes.map((modulo, modIdx) => {
                      const moduloAnterior = arvorePermissoes[modIdx - 1];
                      const mudouDeGrupo = modIdx === 0 || (moduloAnterior?.id === "portal") !== (modulo.id === "portal");
                      const hasSubcategorias = modulo.subcategorias?.length > 0;
                      const perms = hasSubcategorias ? modulo.subcategorias.flatMap((s) => s.permissoes ?? []) : (modulo.permissoes ?? []);
                      const numPerms = perms.length;
                      const isExpanded = modulosExpandidos[modulo.id] === true;
                      const isPermSelected = (p) => {
                        const herdada = permissoesHerdadasGrupos.includes(p.chave);
                        if (herdada) return true;
                        return permissoesSelecionadas.some((s) => s.id === p.chave || (s.label || "").trim() === (p.descricao || "").trim());
                      };
                      const permToItem = (p) => ({ id: p.chave, label: p.descricao || p.chave });
                      const modSelected = perms.filter((p) => isPermSelected(p)).length;
                      const modAllSelected = modSelected === numPerms;
                      const modSomeSelected = modSelected > 0;
                      const handleModuleCheck = (e) => {
                        e.stopPropagation();
                        if (!podeMutarUsuarioNoModal) return;
                        const toAdd = perms.filter((p) => !permissoesHerdadasGrupos.includes(p.chave));
                        if (modAllSelected) {
                          const chavesToRemove = new Set(perms.map((p) => p.chave));
                          const labelsToRemove = new Set(perms.map((p) => (p.descricao || "").trim()));
                          setPermissoesSelecionadas((prev) => prev.filter((s) => !chavesToRemove.has(s.id) && !labelsToRemove.has((s.label || "").trim())));
                        } else {
                          const existing = new Set(permissoesSelecionadas.map((s) => s.id));
                          const newItems = toAdd.map(permToItem).filter((item) => !existing.has(item.id));
                          setPermissoesSelecionadas((prev) => [...prev, ...newItems]);
                        }
                      };
                      return (
                        <Box key={modulo.id}>
                          {mudouDeGrupo && (
                            <Box sx={{ px: 1.25, py: 0.75, bgcolor: "#18316e", borderRadius: 1, mb: 0.75, mt: modIdx === 0 ? 0 : 1.5 }}>
                              <Typography variant="caption" fontWeight={700} sx={{ color: "#fff", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                {modulo.id === "portal" ? "Permissões Portal" : "Permissões Planejamento Tributário"}
                              </Typography>
                            </Box>
                          )}
                          <Box sx={{ mb: 0.75 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              py: 0.875,
                              px: 1.25,
                              cursor: "pointer",
                              bgcolor: "#f1f3f4",
                              borderRadius: 1,
                              "&:hover": { bgcolor: "#e8eaed" },
                            }}
                            onClick={() => setModulosExpandidos((prev) => ({ ...prev, [modulo.id]: !isExpanded }))}
                          >
                            <Box
                              component="span"
                              role="button"
                              tabIndex={0}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                color: "#1976d2",
                              }}
                              onClick={(e) => { e.stopPropagation(); setModulosExpandidos((prev) => ({ ...prev, [modulo.id]: !isExpanded })); }}
                            >
                              {isExpanded ? <ExpandLess sx={{ fontSize: 22 }} /> : <ExpandMore sx={{ fontSize: 22 }} />}
                            </Box>
                            <Checkbox
                              size="small"
                              checked={modAllSelected}
                              indeterminate={modSomeSelected && !modAllSelected}
                              disabled={!podeMutarUsuarioNoModal}
                              onClick={handleModuleCheck}
                              sx={{ p: 0.25 }}
                            />
                            <Typography variant="body2" fontWeight={600} color="text.primary" sx={{ flex: 1 }}>{modulo.nome || modulo.id}</Typography>
                            <Typography component="span" variant="caption" sx={{ px: 1.25, py: 0.35, bgcolor: "#e3f2fd", color: "#1976d2", borderRadius: "16px", fontWeight: 500 }}>{`${modSelected} de ${numPerms} ${numPerms === 1 ? "permissão" : "permissões"}`}</Typography>
                          </Box>
                          {isExpanded && (
                            <Box sx={{ pl: 1.5, borderLeft: "1px solid", borderColor: "#e8e8e8", ml: 0.5 }}>
                              {hasSubcategorias ? (
                                (modulo.subcategorias || []).map((sub) => {
                                  const subKey = `${modulo.id}-${sub.id}`;
                                  const subExpanded = subcategoriasExpandidas[subKey] === true;
                                  const subPerms = sub.permissoes ?? [];
                                  const subSelected = subPerms.filter((p) => isPermSelected(p)).length;
                                  const subAllSelected = subSelected === subPerms.length;
                                  const subSomeSelected = subSelected > 0;
                                  const handleSubCheck = (e) => {
                                    e.stopPropagation();
                                    if (!podeMutarUsuarioNoModal) return;
                                    const toAdd = subPerms.filter((p) => !permissoesHerdadasGrupos.includes(p.chave));
                                    if (subAllSelected) {
                                      const chavesToRemove = new Set(subPerms.map((p) => p.chave));
                                      const labelsToRemove = new Set(subPerms.map((p) => (p.descricao || "").trim()));
                                      setPermissoesSelecionadas((prev) => prev.filter((s) => !chavesToRemove.has(s.id) && !labelsToRemove.has((s.label || "").trim())));
                                    } else {
                                      const existing = new Set(permissoesSelecionadas.map((s) => s.id));
                                      const newItems = toAdd.map(permToItem).filter((item) => !existing.has(item.id));
                                      setPermissoesSelecionadas((prev) => [...prev, ...newItems]);
                                    }
                                  };
                                  return (
                                    <Box key={subKey} sx={{ mb: 0.75, pl: 1, borderLeft: "1px solid", borderColor: "#e8e8e8" }}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                          py: 0.625,
                                          px: 1,
                                          cursor: "pointer",
                                          bgcolor: "#f8f9fa",
                                          borderRadius: 1,
                                          "&:hover": { bgcolor: "#f0f2f5" },
                                        }}
                                        onClick={() => setSubcategoriasExpandidas((prev) => ({ ...prev, [subKey]: !subExpanded }))}
                                      >
                                        <Box
                                          component="span"
                                          role="button"
                                          tabIndex={0}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            color: "#1976d2",
                                          }}
                                          onClick={(e) => { e.stopPropagation(); setSubcategoriasExpandidas((prev) => ({ ...prev, [subKey]: !subExpanded })); }}
                                        >
                                          {subExpanded ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />}
                                        </Box>
                                        <Checkbox
                                          size="small"
                                          checked={subAllSelected}
                                          indeterminate={subSomeSelected && !subAllSelected}
                                          disabled={!podeMutarUsuarioNoModal}
                                          onClick={handleSubCheck}
                                          sx={{ p: 0.25 }}
                                        />
                                        <Typography variant="body2" fontWeight={600} color="text.primary" sx={{ flex: 1 }}>{sub.nome}</Typography>
                                        <Typography component="span" variant="caption" sx={{ px: 1.25, py: 0.35, bgcolor: "#e3f2fd", color: "#1976d2", borderRadius: "16px", fontWeight: 500 }}>{`${subSelected} de ${subPerms.length} ${subPerms.length === 1 ? "permissão" : "permissões"}`}</Typography>
                                      </Box>
                                      {subExpanded && (
                                        <Box sx={{ pl: 3 }}>
                                          {subPerms.map((p) => {
                                            const isHerdada = permissoesHerdadasGrupos.includes(p.chave);
                                            const itemFromTree = { id: p.chave, label: p.descricao || p.chave };
                                            const isExplicitChecked = permissoesSelecionadas.some((s) => s.id === p.chave || (s.label || "").trim() === (p.descricao || "").trim());
                                            const isCheckedDisplay = isHerdada || isExplicitChecked;
                                            return (
                                              <Box
                                                key={p.chave || p.id}
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                  py: 0.625,
                                                  px: 1,
                                                  borderBottom: "1px solid",
                                                  borderColor: "#eee",
                                                  bgcolor: isHerdada ? "#faf9f7" : "#fff",
                                                  "&:last-of-type": { borderBottom: "none" },
                                                }}
                                              >
                                                <Checkbox
                                                  size="small"
                                                  checked={!!isCheckedDisplay}
                                                  disabled={!!isHerdada || !podeMutarUsuarioNoModal}
                                                  onChange={(e) => {
                                                    e.stopPropagation();
                                                    if (isHerdada || !podeMutarUsuarioNoModal) return;
                                                    if (isCheckedDisplay) setPermissoesSelecionadas((prev) => prev.filter((s) => s.id !== p.chave && (s.label || "").trim() !== (p.descricao || "").trim()));
                                                    else setPermissoesSelecionadas((prev) => [...prev, itemFromTree]);
                                                  }}
                                                />
                                                <Typography variant="body2" fontWeight={400} color={isHerdada ? "text.secondary" : "text.primary"} sx={{ flex: 1 }}>{p.descricao || p.chave}</Typography>
                                                {isHerdada && (
                                                  <Chip
                                                    title={herancaGrupoPorChave[p.chave] || ""}
                                                    label={
                                                      herancaGrupoPorChave[p.chave]
                                                        ? `Herdada · ${herancaGrupoPorChave[p.chave]}`
                                                        : "Herdada"
                                                    }
                                                    size="small"
                                                    sx={{
                                                      fontSize: "0.7rem",
                                                      height: 20,
                                                      maxWidth: 220,
                                                      bgcolor: "#ffe0b2",
                                                      color: "#e65100",
                                                      fontWeight: 500,
                                                      "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis" },
                                                    }}
                                                  />
                                                )}
                                              </Box>
                                            );
                                          })}
                                        </Box>
                                      )}
                                    </Box>
                                  );
                                })
                              ) : (
                                (modulo.permissoes ?? []).map((p) => {
                                  const isHerdada = permissoesHerdadasGrupos.includes(p.chave);
                                  const itemFromTree = { id: p.chave, label: p.descricao || p.chave };
                                  const isExplicitCheckedFlat = permissoesSelecionadas.some((s) => s.id === p.chave || (s.label || "").trim() === (p.descricao || "").trim());
                                  const isCheckedDisplayFlat = isHerdada || isExplicitCheckedFlat;
                                  return (
                                    <Box
                                      key={p.chave || p.id}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        py: 0.625,
                                        px: 1,
                                        borderBottom: "1px solid",
                                        borderColor: "#eee",
                                        bgcolor: isHerdada ? "#faf9f7" : "#fff",
                                        "&:last-of-type": { borderBottom: "none" },
                                      }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={!!isCheckedDisplayFlat}
                                        disabled={!!isHerdada || !podeMutarUsuarioNoModal}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          if (isHerdada || !podeMutarUsuarioNoModal) return;
                                          if (isCheckedDisplayFlat) setPermissoesSelecionadas((prev) => prev.filter((s) => s.id !== p.chave && (s.label || "").trim() !== (p.descricao || "").trim()));
                                          else setPermissoesSelecionadas((prev) => [...prev, itemFromTree]);
                                        }}
                                      />
                                      <Typography variant="body2" fontWeight={400} color={isHerdada ? "text.secondary" : "text.primary"} sx={{ flex: 1 }}>{p.descricao || p.chave}</Typography>
                                      {isHerdada && (
                                        <Chip
                                          title={herancaGrupoPorChave[p.chave] || ""}
                                          label={
                                            herancaGrupoPorChave[p.chave]
                                              ? `Herdada · ${herancaGrupoPorChave[p.chave]}`
                                              : "Herdada"
                                          }
                                          size="small"
                                          sx={{
                                            fontSize: "0.7rem",
                                            height: 20,
                                            maxWidth: 220,
                                            bgcolor: "#ffe0b2",
                                            color: "#e65100",
                                            fontWeight: 500,
                                            "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis" },
                                          }}
                                        />
                                      )}
                                    </Box>
                                  );
                                })
                              )}
                            </Box>
                          )}
                          </Box>
                        </Box>
                      );
                    })
                  ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                      Nenhuma permissão disponível na árvore. Verifique se a API de autenticação retornou o catálogo de permissões.
                    </Typography>
                  )}
                </Box>
              </Paper>
              </Box>
            </Box>
        </fieldset>
        </Box>{/* fim conteúdo interno #f5f7fa */}
        </Box>{/* fim card pai título/conteúdo */}
        </Box>{/* fim card externo */}

            {/* Footer fixo: estatísticas em tempo real + ações */}
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mt: 0,
                py: 2,
                px: 3,
                bgcolor: "#fff",
                border: "1px solid",
                borderColor: "#e8e8e8",
                borderRadius: "12px",
                boxShadow: "0 -2px 8px rgba(0,0,0,0.06)",
              }}
            >
              <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 }}>
                <Chip
                  icon={<GroupIcon sx={{ fontSize: 18 }} />}
                  label={gruposSelecionadosLabel}
                  size="small"
                  sx={{ bgcolor: "#e3f2fd", color: "#1565c0" }}
                />
                <Chip
                  icon={<Tune sx={{ fontSize: 18 }} />}
                  label={niveisAssociacaoSelecionadosLabel || "Nenhum nível"}
                  size="small"
                  sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }}
                />
                <Chip
                  icon={<Lock sx={{ fontSize: 18 }} />}
                  label={`${totalPermissoesSelecionadasArvore} permissão(ões) ativas`}
                  size="small"
                  sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <WhiteButton
                  clickFunction={salvandoUsuario ? undefined : solicitarFecharModalEdicao}
                  textValue="Cancelar"
                  customStyle={salvandoUsuario ? { opacity: 0.55, pointerEvents: "none" } : undefined}
                />
                <IfPermissao
                  anyOf={isEdicaoUsuarioExistente(usuSelecionado) ? CHAVES_ATUALIZAR_USUARIO : CHAVES_CRIAR_USUARIO}
                  fallback={null}
                >
                  <BlueButton
                    textValue={
                      salvandoUsuario
                        ? "Salvando..."
                        : isEdicaoUsuarioExistente(usuSelecionado)
                          ? "Salvar Alterações"
                          : "Salvar"
                    }
                    type="submit"
                    disabled={salvandoUsuario}
                  />
                </IfPermissao>
              </Box>
            </Box>
          </Box>{/* fim card externo */}
        </form>

          <ConfirmDialog
            open={confirmDeleteDocOpen}
            onClose={() => { setConfirmDeleteDocOpen(false); pendingDeleteDocRef.current = null; }}
            onClickSim={() => {
              setConfirmDeleteDocOpen(false);
              pendingDeleteDocRef.current?.();
              pendingDeleteDocRef.current = null;
            }}
            title="Remover documento"
            text="Tem certeza que deseja remover este documento? A ação não pode ser desfeita."
            confirmLabel="Remover"
            confirmVariant="error"
          />

          <ConfirmDialog
            open={openConfirmFecharEdicao}
            onClose={() => setOpenConfirmFecharEdicao(false)}
            onClickSim={() => {
              setOpenConfirmFecharEdicao(false);
              fecharModalEdicaoUsuario();
            }}
            title="Descartar alterações?"
            text="Há alterações não salvas. Deseja fechar e voltar à listagem?"
            confirmLabel="Descartar"
          />

          <ConfirmDialog
            open={openPasswordModal}
            onClose={handleClosePasswordModal}
            onClickSim={handleChangePassword}
            title="Redefinir senha"
            text={`Você tem certeza que deseja redefinir a senha do usuário ${usuSelecionado.nomeCompleto || usuSelecionado.email || usuSelecionado.login || ""}? Um e-mail será enviado para ele prosseguir com a alteração.`}
            confirmLabel="Confirmar"
            showWarningIcon={false}
            loading={sendingPasswordEmail}
          />
        </>
      )}
      <MensagemSucesso
        open={snackBar.sucess}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />
    </>
  );
};

export default Usuarios;
